export default {
  "input": {
    "observation": "Observação|Observações",
    "status": "Status",
    "competency": "Competência|Competências",
    "objectCode": "Código do Objeto",
    "uniqueIdentifier": "Identificador Único {name}",
    "search": "Buscar",
    "showInCourses": "Mostrar em Cursos",
    "showInFormations": "Mostrar em Trilhas",
    "showInMidias": "Mostrar em Mídias",
    "nickname": "Apelido",
    "document": "Documento | Documentos",
    "foreignDocument": "Documento Estrangeiro",
    "email": "E-mail",
    "password": "Senha",
    "confirmPassword": "Confirmar Senha",
    "phone": "Número de Telefone",
    "gender": "Gênero | Gêneros",
    "birthDate": "Data de Nascimento",
    "preferredLanguage": "Idioma Preferido",
    "photoUpload": "Upload de Foto",
    "personType": "Tipo de Pessoa",
    "admissionDate": "Data de Admissão",
    "role": "Função",
    "directSupervisor": "Superior Imediato",
    "superiorsInterests": "Interesses do Superior",
    "userInterests": "Interesses do Usuário",
    "smsNotifications": "Notificações por SMS",
    "pushNotifications": "Notificações Push",
    "public": "Público",
    private: "Privado",
    "dragAndDrop": "Arraste e solte o arquivo aqui <br>ou",
    "category": "Categoria | Categorias",
    "expirationDate": "Data de Expiração",
    "resume": "Currículo",
    "createdAt": "Data de Criação",
    "certificateStructure": "Estrutura de Certificado",
    "notShowAgain": "Não exibir este item novamente",
    "copyTitle": "Cópia - {title}",
    "paperSize": "Tamanho do Papel",
    "dpi": "DPI",
    "orientation": "Orientação",
    "autoGenerated": "Gerado automaticamente"
  },
  "button": {
    "syncUsers": "Sincronizar Usuários",
    "ok": "Ok",
    "close": "Fechar",
    "consultBatch": "Consultar",
    "share": "Compartilhar",
    "save": "Salvar",
    cancel: "Cancelar {text}",
    remove: "Remover {text}",
    disable: "Desativar {text}",
    enable: "Ativar {text}",
    "viewTermsOfUse": "Ver Termos de Uso",
    "back": "Voltar",
    "send": "Enviar",
    "myLearning": "Meu Aprendizado",
    "learnMore": "Aprenda Mais",
    "myFavorites": "Meus Favoritos",
    continue: "Continuar",
    open: "abrir",
    "subscribe": "Inscrever",
    "unenroll": "Desinscrever",
    "read": "Ler | Lido",
    "expired": "Expirado",
    "fullscreen": "Alternar Tela Cheia",
    "listen": "Ouvir",
    "watch": "Assistir",
    "loadMore": "Carregar Mais",
    "details": "Detalhes",
    "seeAll": "Ver todos",
    explore: "Explorar",
    "seeAgain": "Ver Novamente",
    "listenAgain": "Ouvir Novamente",
    "start": "Iniciar",
    "view": "Visualizar",
    viewEdit: "Ver/Editar",
    "viewed": "Visualizado",
    "classRoom": "Sala de Aula",
    "access": "Acessar",
    "download": "Download {text}",
    "darkMode": "Modo Escuro",
    "lightMode": "Modo Claro",
    "export": "Exportar",
    "clear": "Limpar {text}",
    "today": "Hoje",
    "yesterday": "Ontem",
    "thisWeek": "Esta Semana",
    "thisMonth": "Este Mês",
    "resetPassword": "Redefinir Senha",
    "batchPassword": "Alterar Senha em Lote",
    "delete": "Excluir {text}",
    "markAsRead": "Marcar como visualizado",
    "update": "Atualizar",
    "add": "Adicionar {text}",
    "list": "Lista",
    "seeMore": "Ver Mais",
    "confirm": "Confirmar",
    "help": "Ajuda",
    "clientMode": "Modo Cliente",
    "next": "Avançar",
    "saveExit": "Salvar e Sair",
    "expand": "Expandir",
    "collapse": "Recolher",
    "hide": "Ocultar",
    "edit": "Editar",
    "automation": "Automação",
    "import": "Importar",
    "changePermission": "Alterar Permissão",
    "removePermission": "Remover Permissão",
    "changePassword": "Alterar Senha",
    "changeEmail": "Alterar E-mail",
    "validateFile": "Validar Arquivo",
    "importData": "Importar Dados",
    "newImport": "Nova Importação",
    "processing": "Processando...",
    "associations": "Associações",
    assignEvaluator: "Atribuir Avaliador",
    "changeImage": "Alterar Imagem",
    "viewPreview": "Visualizar Prévia",
    "addYoutubeLink": "Adicionar link do YouTube",
    "insert": "Inserir",
    "new": "Novo {text} | Nova {text}",
    "text": "Texto",
    "htmlCode": "Código HTML",
    "button": "Botão",
    "checkAll": "Marcar todos",
    "uncheckAll": "Desmarcar todos",
    "checkAllVisible": "Marcar visíveis",
    "uncheckAllVisible": "Desmarcar visíveis",
    "revert": "Reverter",
    "accept": "Aceitar",
    "tryAgain": "Tentar Novamente",
    "set": "Definir",
    "exit": "Sair",
    "applyFilters": "Aplicar Filtros",
    "resubscribe": "Reinscrever-se",
    "approve": "Aprovar",
    "deny": "Negar",
    "generateCertificate": "Gerar certificado",
    "currentItem": "Ir para questão atual",
    previousQuestion: "Questão Anterior",
    nextQuestion: "Próxima Questão",
    "submitAnswer": "Enviar Resposta",
    "finish": "Finalizar",
    "startTest": "Iniciar avaliação",
    "continueTest": "Continuar avaliação",
    "notAnswer": "Não responder",
    "returnLogin": "Retornar ao Login",
    "copyLink": "Copiar link",
    login: "Acessar minha conta",
    "editUserEmail": "Editar e-mail do usuário",
    "studentInscriptions": "Inscrições dos alunos",
    "createQrCode": "Criar código QR para este objeto",
    "automateJourneys": "Automatizar jornadas",
    "reviewRequest": "Analisar solicitação",
    "print": "Imprimir {text}",
    "firstPage": "Primeira página {text}",
    "press": "Pressione {text}",
    "nextPage": "Próxima página {text}",
    "lastPage": "Última página {text}",
    "lastPageViewed": "Última página visualizada {text}",
    "unselectSelected": "Desmarcar selecionados",
    "removeSelected": "Remover selecionados",
    "clone": "Clonar",
    "executeFlow": "Executar o fluxo de notificação manualmente",
    "accessLink": "Acessar Link",
    "accessNow": "Acessar agora",
    "exitContract": "Sair do contrato",
    "listing": "Listagem",
    "nextContent": "Próximo Conteúdo",
    "previousContent": "Conteúdo Anterior",
    "leaveClassroom": "Sair da Sala de Aula",
    "addQuestions": "Adicionar Perguntas",
    "backListAssessment": "Voltar para Lista de Avaliações de Conhecimento",
    "detailsAssessment": "Visualizar Detalhes da Avaliação",
    "finishAssessment": "Finalizar Avaliação",
    "continueAssessment": "Continuar Avaliação",
    "endAssessment": "Encerrar Avaliação",
    "sendSuggestion": "Enviar Sugestão",
    "goToLoginSettings": "Ir para Configurações de Login",
    "respondAssessment": "Responder Avaliação",
    "seeResult": "Ver Resultado",
    "backMyAssessments": "Voltar para minhas avaliações",
    "style": "Estilo",
    "parameterizations": "Parametrizações",
    "zoomIn": "Aumentar zoom",
    "zoomOut": "Diminuir zoom",
    "accessInfo": "Acessar Informações",
    "singlePageView": "Visualização de página única",
    "allPagesView": "Visualização de todas as páginas",
    home: 'Home',
    catalog: 'Catálogo',
    buttonText: 'Texto do Botão'
  },
  "units": {
    "day": "Dia|Dias"
  },
  "labels": {
    select: "Selecionar {text}",
    row: "Linha|Linhas",
    "denied": "Negado",
    "course": "Curso | Cursos",
    "verticalCover": "Capa Vertical|Capas Verticais",
    "horizontalCover": "Capa Horizontal|Capas Horizontais",
    "document": "Documento | Documentos",
    "trail": "Trilha | Trilhas",
    "link": "Link | Links",
    "visitLink": "Visitar Link",
    "video": "Vídeo|Vídeos",
    "podcast": "Podcast | Podcasts",
    "scorm": "Scorm | Scorms",
    "pdf": "PDF | PDFs",
    "image": "Imagem | Imagens",
    "photo": "Foto|Fotos",
    value: "Valor|Valores",
    login: "Login",
    "of": "de",
    "items": "Itens",
    "showing": "Exibindo",
    "progress": "Progresso",
    "all": "Todos | Todas",
    "media": "Mídia|Mídias",
    "actions": "Ações | Ação",
    "notStarted": "Não iniciado",
    "complete": "Completo",
    "completed": "Concluído",
    "listPerPage": "Lista por página",
    "selected": "Selecionado|Selecionados",
    "pagination": "Mostrando {min} - {max} de {total}",
    "currentPage": "{current} de {total} páginas",
    "fullname": "Nome Completo",
    "calledBy": "Prefiro ser chamado por",
    "preferLanguage": "Meu idioma preferido",
    "skill": "Competência | Competências",
    "supervisor": "Superior Imediato",
    "educationLevel": "Nível de Educação",
    "unit": "Unidade | Unidades",
    "department": "Departamento | Departamentos",
    "departmentDescription": "Descrição do departamento",
    "jobTitle": "Cargo | Cargos",
    "jobDescription": "Descrição do cargo",
    "aiRecommended": "Recomendado por IA",
    "pending": "Pendente",
    "approved": "Aprovado",
    "failed": "Falhou",
    "onGoing": "Em andamento",
    "total": "Total",
    "content": "Conteúdo | Conteúdos",
    "user": "Usuário | Usuários",
    "active": "Ativo|Ativos",
    "inactive": "Inativo|Inativos",
    "visible": "Visível|Visíveis",
    "hidden": "Oculto|Ocultos",
    "yes": "Sim",
    "no": "Não",
    "filter": "Filtro | Filtros",
    "search": "Pesquisar",
    "cnpj": "CNPJ",
    "cpf": "CPF",
    "naturalPerson": "Física",
    "legalEntity": "Jurídica",
    "foreign": "Estrangeiro",
    "companyName": "Nome da Empresa",
    "landlineNumber": "Número Fixo",
    "mobilePhone": "Telefone Móvel",
    "fantasyName": "Nome Fantasia",
    "district": "Bairro",
    "state": "Estado",
    "city": "Cidade",
    "country": "País",
    "homeNumber": "Número Residencial",
    "address": "Endereço",
    "adjunct": "Complemento",
    "customerActivity": "Atividade do Cliente",
    "zipCode": "CEP",
    "number": "Número",
    "company": "Empresa",
    "aliareCode": "Código Aliare",
    "date": "Data",
    "projectStatus": "Status do Projeto",
    "products": "Produtos",
    "numContractedUsers": "Limite de usuários",
    "activeUsers": "Usuários ativos: {count}",
    "editField": "Editar campo",
    "contractedDiskSpace": "Limite Armazenamento {0}",
    "communicationEmail": "E-mail de comunicação usado pela empresa",
    "embedded": "Embarcado",
    "embedLink": "Incorporar Link",
    "partner": "Parceiro",
    "customerClassification": "Classificação do cliente",
    "generalWarehousesTradings": "Armazéns gerais e tradings",
    "otherLargeClients": "Outros clientes de grande porte",
    "agriculturalProducers": "Produtores agrícolas, sementeiras, algodoeiras e afins",
    "dealership": "Concessionária",
    "agroRetail": "Varejo de insumos e agropecuário",
    "foreignFemale": "Estrangeira",
    "adhesionAgreement": "Termo de Adesão",
    "experimentation": "Experimentação",
    "didactica": "Didactica",
    "distributor": "Distribuidor",
    "inProduction": "Em Produção",
    "blocked": "Bloqueado",
    "canceled": "Cancelado",
    "code": "Código",
    "ordering": "Ordenação",
    "asc": "Crescente",
    "desc": "Decrescente",
    "display": "Exibição",
    "settings": "Configurações",
    "forceUpdatePermission": "Forçar Atualização de Permissão",
    "noPermission": "Sem Permissão",
    "permission": "Permissão | Permissões",
    "clickHere": "Clique aqui",
    "and": "e",
    "selectFile": "Selecionar arquivo",
    "audio": "Áudio|Áudios",
    "file": "Arquivo",
    "objectCode": "Código do {type}",
    "cardImage": "Imagem do Card",
    "summary": "Resumo",
    "fileName": "Nome do Arquivo",
    "fileSize": "Tamanho do Arquivo",
    "scormType": "Tipo Scorm",
    "object": "Objeto | Objetos",
    "diagnostic": "Diagnóstico",
    "reaction": "Reação|Reações",
    "requirement": "Requisito|Requisitos",
    "relatedContent": "Conteúdo Relacionado|Conteúdos Relacionados",
    "noDescription": "Sem descrição",
    "learning": "Aprendizagem",
    "applicability": "Aplicabilidade",
    "result": "Resultado",
    assessmentType: "Tipo de Avaliação",
    "order": "Ordem",
    "statement": "Declaração",
    "questionType": "Tipo de Pergunta",
    requiredScore: "Aproveitamento Mínimo (%)",
    "newAttempt": "Permitir Nova Tentativa?",
    "numAttempt": "Número de Tentativas",
    "automatic": "Automático",
    "showTimer": "Adicionar Temporizador na Avaliação",
    assessment: "Avaliação | Avaliações",
    "never": "Nunca",
    "always": "Sempre",
    "whenReject": "Quando reprovado",
    "objective": "Objetiva",
    "multipleChoice": "Múltipla Escolha",
    "trueOrFalse": "Verdadeiro / Falso",
    "scale": "Escala",
    "essay": "Dissertativa",
    "typeQuestions": "Escolha o tipo de pergunta",
    "attachImage": "Anexar Imagem | Anexar Imagens",
    alternative: "Alternativa|Alternativas",
    "customFeedback": "Feedback Personalizado?",
    "feedbackCorrect": "Feedback Quando Correto",
    "feedbackIncorrect": "Feedback Quando Incorreto",
    "feedbackResponding": "Feedback Quando Respondendo à Pergunta",
    "question": "Questão | Questões",
    "synopsis": "Sinopse",
    "mandatorySequence": "Sequência Obrigatória",
    "daysLimit": "Limite de dias para conclusão",
    "mandatoryCompletion": "Conclusão Obrigatória",
    "challenge": "Desafio | Desafios",
    "termOfUse": "Termo de Uso|Termos de Uso",
    "termOfAgreement": "Termo de Aceite|Termos de Aceite",
    "section": "Seção|Seções",
    "learningObjects": "Objetos de Aprendizagem",
    "step": "Etapa | Etapas",
    "sortSections": "Ordenar Seções",
    "associate": "Vincular {title}",
    "communication": "Comunicação | Comunicações",
    "insertLink": "Inserir um link",
    "use": "Usar {field}",
    "segmentation": "Segmentação | Segmentações",
    "publicationPeriod": "Período de Publicação",
    "certificate": "Certificado|Certificados",
    "certification": "Certificação|Certificações",
    "featuredCommunications": "Comunicações em Destaque",
    "post": "Postagem",
    "displayCommunication": "Sempre exibir comunicações em destaque?",
    "event": "Evento",
    "interval": "Intervalo",
    "daysSubmission": "Dias para Envio",
    "daysNoAccess": "Dias sem Acesso à Plataforma",
    "additionalRecipient": "Destinatário Adicional",
    "subject": "Assunto",
    "draft": "Rascunho",
    "published": "Publicado",
    "copySuperior": "Copiar Superior Imediato no e-mail?",
    "copy": "Copiar",
    "noCopy": "Não copiar",
    "notificationEvent": "Qual é o evento de notificação?",
    "sendingInterval": "Intervalo de Envio de E-mail",
    "days": "Dias",
    "provideEmail": "Informe um email para teste.",
    "templateLayout": "Layout do Template",
    "templatePreview": "Visualização do Template",
    "greetings": "Olá <strong>{name}</strong>",
    "undefined": "Indefinido",
    "achievements": "Conquistas",
    "page": "Página | Páginas",
    "classification": "Classificação",
    "typeContent": "Tipo de Conteúdo",
    "daysCompleted": "Dias para Concluir",
    "rule": "Regra | Regras",
    "applicationPeriod": "Período de Aplicação",
    "to": "Para | Até",
    "completeWithin": "Concluir em até",
    "score": "Pontuação",
    "conquest": "Conquista",
    "useMedia": "Utilizada em mídias",
    "useCourses": "Utilizada em cursos",
    "useTrails": "Utilizada em trilhas",
    "useTests": "Utilizada em avaliações",
    "repository": "Depósito | Depósitos",
    "operator": "Operador",
    "or": "Ou",
    "male": "Masculino",
    "female": "Feminino",
    "nonBinary": "Não Binário",
    "debug": "Debug",
    "showGuidelines": "Exibir linhas guias",
    "background": "Fundo",
    "changeBackground": "Alterar imagem de fundo",
    "removeBackground": "Remover imagem de fundo",
    "flipHorizontally": "Inverter horizontalmente",
    "flipVertically": "Inverter verticalmente",
    "element": "Elemento | Elementos",
    "addText": "Adicionar Texto",
    "addImage": "Adicionar Imagem",
    "simulateValues": "Simular valores",
    "preview": "Prévia {text}",
    "tag": "Tag | Tags",
    "certificateId": "ID do Certificado",
    option: "Opção|Opções",
    optional: "Opcional|Opcionais",
    "moreOptions": "Mais Opções",
    "opacity": "Opacidade | Opacidades",
    "width": "Largura",
    "height": "Altura",
    "align": "Alinhamento | Alinhamentos",
    "layer": "Camada | Camadas",
    "formatting": "Formatação",
    "textColor": "Cor do Texto",
    "font": "Fonte",
    "textSize": "Tamanho do Texto",
    "italic": "Itálico",
    "bold": "Negrito",
    underline: "Sublinhado",
    rotation: "Rotação",
    positioning: "Posicionamento",
    "mine": "Meu",
    "lightTheme": "Tema Claro",
    "darkTheme": "Tema Escuro",
    "pageIcon": "Ícone da Página",
    "corporativeEducation": "Educação Corporativa",
    "interface": "Interface",
    "primaryColor": "Cor Primária",
    "fontColor": "Cor da Fonte",
    "autoFontColor": "Cor da Fonte Automática?",
    "secondColor": "Segunda Cor",
    color: "Cor|Cores",
    backgroundColor: "Cor de Fundo",
    pick: "Escolher",
    left: "Esquerda",
    right: "Direita",
    center: "Centro",
    justified: "Justificado",
    syllabus: "Conteúdo Programático",
    aboutCourse: "Sobre o curso",
    aboutTrail: "Sobre a trilha",
    backOfCertificate: "Verso do Certificado",
    "dateTime": "Data & Hora",
    "username": "Nome de Usuário",
    "revertChanges": "Reverter Alterações",
    "menu": "Menu",
    "for": "para",
    "character": "Caractere | Caracteres",
    "example": "Exemplo",
    "privacyPolicy": "Política de Privacidade",
    "hi": "Oi",
    "default": "Padrão",
    "homePage": "Página Inicial",
    "previousPage": "Página Anterior {text}",
    "table": "Tabela",
    "notRegistered": "Não inscritos",
    "both": "Ambos",
    "automatedNotification": "Notificação automatizada",
    "externalCertificate": "Certificado Externo",
    "person": "Pessoa",
    "started": "Iniciado",
    "transfer": "Transferência",
    "autoPlay": "Auto play",
    "nextActivity": "Próxima atividade em",
    "extension": "Extensão",
    "vocational": "Profissionalizante",
    "academic": "Acadêmico",
    "specialization": "Especialização",
    "describeOthers": "Outros (descreva)",
    "other": "Outro | Outros",
    "copied": "Copiado",
    "copyLink": "Copiar link",
    "dissociate": "Desvincular",
    "reject": "Rejeitar",
    "newEmail": "Novo E-mail",
    "confirmEmail": "Confirme o e-mail",
    "registered": "Inscritos",
    "unnamed": "Sem nome",
    "noUnit": "Sem unidade",
    "setDate": "Definir data",
    "selectAllPage": "Selecionar todos da página",
    "unmarkAllPage": "Desmarcar todos da página",
    "invertSelection": "Inverter seleção da página",
    "tablePage": "{0}/Página",
    "linkLinkedin": "Vincular ao LinkedIn",
    "shareLinkedin": "Compartilhar no LinkedIn",
    "myCertificate": "Meu certificado",
    "externalLink": "Link externo",
    "remaining": "Restante",
    "attempts": "Tentativas",
    "attemptsRealized": "Tentativas Realizadas",
    "maximumAttempts": "Tentativas Máximas",
    "minimumGrade": "Nota mínima",
    "timeSpent": "Tempo gasto",
    "hit": "Acerto | Acertos",
    "miss": "Erro | Erros",
    obtainedScore: "Nota obtida",
    "viewAnswer": "Exibir gabarito",
    "viewAsList": "Exibir como lista",
    "viewAsCards": "Exibir como cartões",
    "attemptsExhausted": "Tentativas esgotadas",
    "myAnswers": "Minha resposta | Minhas respostas",
    "correctAnswers": "Respostas corretas",
    "response": "Resposta",
    "theMedia": "A {object} | O {object}",
    "studyPlan": "Plano de Estudo",
    "contract": "Contrato | Contratos",
    "field": "Campo",
    "fieldName": "Nome do Campo",
    "data": "Dados",
    "congratulations": "Parabéns",
    "goTo": "Ir para {0}",
    "conclusion": "Conclusão | Concluído",
    "educationalInstitution": "Instituição de ensino",
    "typeCourse": "Tipo de curso",
    "import": "Importação de {type}",
    "incorrect": "Incorreto | Incorretos",
    "correct": "Correto | Corretos",
    "answerList": "Gabarito",
    "note": "Nota | Notas | Anotação | Anotações",
    "notification": "Notificação | Notificações",
    "notImplemented": "Não implementado",
    "advanced": "Avançado",
    "publicPanel": "Painel Público",
    "replicate": "Replicar Cadastros do Distribuidor",
    "panel": "Painel | Paineis",
    "report": "Relatório",
    "logo": "Logo | Logos",
    "banner": "Banner | Banners",
    "pageTitleAndPageDescription": "Titulo da Página e Descrição da Página",
    "loginImage": "Imagem de Login",
    "loginBoxPosition": "Posição da Caixa de Login",
    "logoutAddress": "Endereço de Logout",
    "privacyPolicyAddress": "Endereço da Política de Privacidade",
    "standardTermsOfUse": "Termo de Uso Padrão",
    "certificates": "Certificados",
    "standardCertificate": "Certificado Padrão",
    "remove": "Remover",
    "correctOrIncorrect": "Correta ou Incorreta",
    "trueOrFalses": "Verdadeira ou Falso",
    "unitCode": "<strong>Código:</strong> {title}",
    "pt": "Português",
    "en": "Inglês",
    "es": "Espanhol",
    "expirationDate": "Expira em: {date}",
    "reactions": "{count} Reação | {count} Reações",
    "react": "Reagir",
    "reacted": "Reagido",
    "dateExpiration": "Dt. Vencimento",
    "inscriptionDate": "Dt. Inscrição",
    "practice": "Prática",
    "behavior": "Comportamento",
    "linkManager": "Vincular Gestor Avaliador",
    "evaluatorManager": "Gestor Avaliador",
    "linkTargeting": "Vincular Segmentação",
    "microphone": "Microfone",
    "screen": "Tela",
    "camera": "Câmera",
    "uploadType": "Tipo de Upload",
    "typeOfAnswer": "Tipo de Resposta",
    maxScore: "Nota Máxima",
    "courseOrTrail": "Curso/Trilha",
    "availableIn": "Disponível em",
    "heldIn": "Realizado em",
    "ratedIn": "Avaliado em",
    "disapproved": "Reprovado",
    "newTry": "Nova Tentativa",
    "behaviorAssessment": "Avaliações de Comportamento | Avaliação de Comportamento",
    "myAssessments": "Minhas Avaliações",
    reviewAssessment: "Revisar Avaliação",
    reviewing: "Revisando: {title}",
    "closingAssessment": "Encerrando Avaliação",
    "timeUsed": "Tempo Utilizado",
    "partialGrade": "Nota Parcial",
    "landscape": "Paisagem",
    "portrait": "Retrato",
    carousel: "Carrossel|Carrosséis",
    slide: "Slide|Slides",
    "answersCorrect": "Resposta correta",
    "answersIncorrect": "Resposta incorreta",
    "answersPartiallyCorrect": "Resposta parcialmente correta",
    "evaluator": "Avaliador",
    "withdrawal": "Desistência",
    "notAnswered": "Não Respondido",
    "pendingCorrection": "Pendente de Correção",
    "assessmentsCorrection": "Correções de Avaliações",
    "assessmentId": "Id da Avaliação",
    "finalConsiderations": "Considerações Finais",
    "practicalQuestion": "Questão Prática",
    "dissertativeQuestion": "Questão Dissertativa",
    "responseSended": "Resposta enviada com êxito",
    "evaluatorCorrection": "Correção do Avaliador",
    "attemptsDescription": "Tentativas Realizadas / Tentativas Máximas",
    "evaluatorSet": "Definir como Avaliador",
    "disapprovedByGrade": "Reprovado por Nota",
    "introduction": "Introdução",
    "closing": "Encerramento",
    "showDescription": "Exibir descrição",
    "interactiveLink": "Link Interativo",
    "enterLink": "Informe um link",
    "fileSettings": "Configurações do Arquivo",
    "disabledFasForward": "Proibir avanço rápido",
    "batchMode": "Aplicar em massa ?",
    "certificateValidityOption": "Opção de Validade do Certificado",
    "notHaveValidity": "Não possui validade",
    "daysFromAvailability": "Dias a partir da disponibilidade",
    "fixedDate": "Por uma data fixa",
    "numberOfDays": "Quantidade de dias",
    "accessLinkDescription": "Seu aprendizado está a um clique de distância!",
    front: "Frente",
    back: "Verso",
    sendToBack: "Enviar para o fundo",
    moveBackward: "Mover para trás",
    moveForward: "Mover para frente",
    bringToFront: "Trazer para frente",
    "certificateType": "Tipo de Certificado",
    "cannotBeChanged": "não pode ser alterado",
    "atAnyTime": "A Qualquer Momento",
    "specificDateTime": "Data e Hora Específica",
    "enablePrerequisites": "Habilitar Pré-Requisitos",
    "selectCourses": "Selecione o(s) curso(s)",
    "selectTrails": "Selecione a(s) trilha(s)",
    "consumptionControl": "Controle de Consumo",
    "prerequisites": "Pré-Requisitos",
    "contentRelease": "Liberação do Conteu̝do",
    "consumptionControlConfiguration": "Configuração de Controle de Consumo",
    "registration": "Matrícula",
    horizontal: "Horizontal",
    vertical: "Vertical",
    sectionType: "Tipo de Seção",
    preRequisites: "Possui Pré-Requisitos",
    comsuptionControl: "Possui Controle de Consumo",
    criteria: "Critério|Critérios",
    calculationInterval: "Período do Cálculo",
    top10: "Top 10",
    release: "Lançamento|Lançamentos",
    enrollment: "Inscrição|Inscrições",
    completion: "Conclusão|Conclusões",
    creationDate: "Data de Criação",
    consumptionControlDate: "Data de Controle de Consumo",
    manual: "Manual",
    automated: "Automatizado",
    weekly: "Semanal",
    monthly: "Mensal",
    newTab: "Abrir Url em Nova Aba",
    enterUrl: "Informe a url de redirecionamento do botão",
    enterText: "Informe o texto do botão",
    enabled: "Habilitado",
    disabled: "Desabilitado",
    yourTextHere: "Seu Texto Aqui",
    redirectButton: "Botão de Redirecionamento",
    outlineButton: "Botão Contornado",
    "autoPosition": "Auto Cargo",
    "autoUnit": "Auto Unidade",
    "imports": "Importação",
    "externalPage": "Pagina Externa",
    redirectUrl: "Url de Redirecionamento",
    bannerSentByDistributor: "Banner enviado por distribuidor",
    "indicatorName": "Nome do Indicador",
    "anonymous": "Anônimo",
    "frequency": "Frequência",
    'wellBeingIndicator': 'Indicador de Bem-estar',
    'emojiStyle': 'Estilo de Emoji',
    'static': 'Estático',
    'animated': 'Animado',
    'userDefined': 'Definido pelo Usuário',
    'light': 'Claro',
    'dark': 'Escuro',
    'selectContracts': 'Selecionar o(s) Contrato(s)',
    'brazil': 'Brasil',
    'paraguay': 'Paraguai',
    "equal": "Igual",
    "notEqual": "Diferente",
    "comparisonOperator": "Comparador",
    "freeContent": "Conteúdo Criado | Conteúdos Criados",
    'associateEvaluator': 'Vincular Avaliador',
    'selection': 'Seleção',
    byCoursesTrails: 'Por Cursos/Trilhas',
    byStudents: 'Por Alunos',
    "userAssociation": "Associação de Usuários",
    provision: 'Vínculo|Vínculos',
    provisioned: 'Vínculado|Vínculados',
    forAllCompany: 'Para toda a empresa?',
    journeyReach: 'Alcance da Jornada',
    coverImg: "Imagem de Capa",
    bgImg: "Imagem de Fundo",
    limitReached: "Limite alcançado",
    aiContext: "Contexto de IA",
    enableAiContext: "Habilitar Contexto de IA",
    aiContextDescription: "Descrição para Contexto de IA",
    aiContextAdditionalInfo: "Informações Complementares para IA",
    aiContextAutoGenerated: "Contexto Adicionado Automaticamente",
    notInformed: "Não informado",
    notInformedFemale: "Não informada",
    contractValue: "Valor do Contrato"
  },
  "fileType": {
    "spreedsheet": "Planilha | Planilhas",
    "textDocument": "Documento de Texto | Documentos de Texto",
    "presentation": "Apresentação | Apresentações"
  },
  "placeholder": {
    "select": "Selecionar {field}",
    "email": "Digite seu e-mail",
    "password": "Digite sua senha",
    "newPassword": "Digite sua nova senha",
    "confirmPassword": "Confirme sua senha",
    "uniqueIdentifier": "Informe o identificador único {name}",
    "learnToday": "O que aprenderemos hoje?",
    "search": "Pesquisar {field}",
    "searchCompetencies": "Pesquisar por competências",
    "searchCategories": "Pesquisar por categorias",
    "searchContentType": "Pesquisar por tipo de conteúdo",
    "searchOrigin": "Pesquisar por origem",
    "searchContentQuestion": "Pesquisar conteúdo?",
    "quickSearch": "Pesquisa rápida",
    "searchFuncionality": "Qual funcionalidade você deseja pesquisar?",
    "help": "Ajuda",
    "fullname": "Digite seu Nome Completo",
    "zipCode": "Digite seu CEP",
    "address": "Digite seu Endereço",
    "enter": "Digite {field} | Digite sua {field} | Digite seu {field} | Digite a {field} | Digite o {field}",
    "sectionsAssociate": "Associar seções plantares",
    "communicationsAssociate": "Associar comunicações",
    "clickToAssociate": "Clique para associar {field}",
    "score": "Digite a pontuação entre {0} e {1}",
    "statement": "Digite a declaração da pergunta que será apresentada ao aluno...",
    "feedbackCorrect": "Digite o feedback que será apresentado ao aluno quando ele responder corretamente à pergunta...",
    "feedbackIncorrect": "Digite o feedback que será apresentado ao aluno quando ele responder incorretamente à pergunta...",
    "feedbackResponding": "Digite o feedback que será apresentado ao aluno quando ele responder à pergunta...",
    "postContent": "Conteúdo da postagem",
    "selectMultiple": "Selecione um ou mais {field}",
    "uploadImage": "Envie sua imagem",
    "subject": "Forneça um assunto para o e-mail.",
    "enterPasteScript": "Insira/cole aqui o script adicional",
    "enterPasteScriptContent": "Insira/cole o conteúdo do script",
    "enterPasteScriptName": "Insira o nome/identificador do script (opcional)",
    "enterPasteAdress": "Insira/cole o endereço do script (opcional)",
    "insertLink": "Insira o endereço de redirecionamento do banner. Exemplo: https://www.seusite.com.br",
    "confirm": "Confirme {field}",
    "reason": "Informe o motivo da exclusão",
    "answerHere": "Escreva sua resposta aqui",
    "enterNickname": "Informe o apelido",
    "enterDocument": "Informe o documento",
    "enterTitle": "Informe o titulo",
    "enterId": "Informe o ID",
    "enterDescription": "Informe a descrição",
    "enterObservation": "Informe as observações",
    "jobDescription": "Descreva o propósito do cargo, suas principais responsabilidades e atividades, destacando o que se espera do profissional nesta função.",
    "departmentDescription": "Descreva a finalidade do departamento, suas principais responsabilidades e sua atuação dentro da organização.",
    "userObservation": "Registre informações complementares sobre o usuário que sejam relevantes para sua gestão e jornada de aprendizagem.",
    "repositoryDescription": "Descreva o objetivo do conteúdo, os principais temas abordados e como ele contribui para o desenvolvimento do aluno.",
    "assessmentObservation": "Descreva o objetivo da avaliação, os conhecimentos ou competências que serão avaliados e os resultados esperados.",
    "courseSynopsis": "Apresente um breve resumo do curso, destacando o tema principal e os benefícios que o aluno terá ao realizá-lo.",
    "courseDescription": "Descreva os objetivos de aprendizagem, os principais conteúdos abordados, o público-alvo e as competências que serão desenvolvidas ao longo do curso.",
    "trailSynopsis": "Apresente um breve resumo da trilha, destacando seu propósito e os benefícios que o aluno terá ao concluir a jornada de aprendizagem.",
    "trailDescription": "Descreva os objetivos da trilha, o público-alvo, os principais temas e etapas da jornada e as competências que serão desenvolvidas ao longo do percurso.",
    "sectionDescription": "Descreva o propósito da seção e os tipos de conteúdos que serão apresentados, ajudando o aluno a identificar o que encontrará neste espaço.",
    "journeyObservation": "Descreva o propósito da jornada, as experiências de aprendizagem que o aluno vivenciará, a sequência de desenvolvimento e os resultados esperados ao concluir o percurso.",
    "wellBeingIndicatorDescription": "Descreva o que este indicador busca avaliar, sua importância para o bem-estar dos colaboradores e como seus resultados podem contribuir para a melhoria do ambiente de trabalho.",
    "competitionSummary": "Apresente brevemente o propósito da competição, destacando o desafio proposto e o que os participantes poderão conquistar.",
    "teamDescription": "Descreva o propósito do time, sua identidade e como seus integrantes participarão juntos dos desafios e competições de gamificação.",
    "competencyObservation": "Descreva a competência, destacando os conhecimentos, habilidades e atitudes necessários, como ela se manifesta na prática e sua contribuição para o desempenho profissional.",
    "categoryObservation": "Selecione onde esta categoria poderá ser utilizada: Depósito, Cursos, Trilhas e/ou Avaliações. É possível selecionar mais de uma opção para utilizar a mesma categoria em diferentes áreas da plataforma.",
    "termsOfUseObservation": "Descreva as condições de utilização da plataforma, os direitos e responsabilidades dos usuários, as regras de acesso e as orientações que deverão ser conhecidas e aceitas.",
    "segmentationObservation": "Descreva o objetivo da segmentação, o público que ela representa e como será utilizada para direcionar conteúdos, seções e experiências de aprendizagem na plataforma.",
    "searchContent": "Busque por cursos, temas ou competências...",
    "enterName": "Informe o nome",
    "enterEmail": "Informe o email",
    "enterContent": "Informe o conteúdo",
    "enterFantasyName": "Informe o nome fantasia",
    "enterAddress2": "Informe o complemento do endereço",
    "enterDistrict": "Informe o bairro",
    enterClassification: "Informe a classificação",
    "enterCpf": "Informe o CPF",
    "enterCnpj": "Informe o CNPJ",
    "enterCpfCnpj": "Informe o CPF/CNPJ",
    "enterForeignDocument": "Informe o documento estrangeiro",
    "enterFullName": "Informe o nome completo",
    "enterCompanyName": "Informe o nome da empresa",
    "enterAlternative": "Informe a alternativa {title}",
    "enterAdditionalRecipient": "Informe o destinatário adicional",
    "enterNumberOfDays": "Informe o número de dias",
    "enterNumberOfUsers": "Informe o número de usuários",
    "enterDiskSpace": "Informe o espaço em disco (GBs)",
    "enterCourseLimit": "Informe a quantia limite de cursos",
    "enterTrailsLimit": "Informe a quantia limite de trilhas",
    "enterDefaultUrl": "Informe a URL padrão",
    "enterCustomUrl": "Informe a URL personalizada",
    "enterSynopsis": "Informe a sinopse",
    "enterCode": "Informe o código",
    "enterSumary": "Informe o resumo",
    "enterObjectCode": "Informe o código do objeto",
    "enterInstitution": "Informe a instituição",
    "enterLinkBanner": "Insira o endereço da web que será redirecionado o banner",
    "numberDays": "Nº de dias",
    "contentSearch": "O que você quer aprender hoje?",
    "suggestions": "Sugira um nova mídia, trilha, curso ou tema que gostaria de ver na plataforma.",
    "noResults": "Não encontrou o que procurava? Envie suas sugestões de conteúdo para ajudarmos a melhorar sua experiência na plataforma!",
    "enterTheNote": "Digite a nota",
    "certificateCode": "Código da Credencial",
    "autoGenerated": "Gerado automaticamente",
    "enterRegistration": "Informe a matrícula",
    "availableAt": "Disponível em: {date}",
    "aiContextDescription": "Descreva o conteúdo para melhorar as buscas semânticas por IA...",
    "enterContractValue": "Informe o valor do contrato"
  },
  "tooltips": {
    required0: "Campo obrigatório (mesmo que seja 0)",
    "toggleOrder": "Alternar Ordenação",
    "unreadNotifications": "Notificações não lidas",
    "searchShortcut": "Dica! Você pode abrir essa janela apertando o atalho <kbd>Ctrl</kbd> + <kbd>K</kbd>",
    "associateMedias": "Associar vídeos, áudios, imagens, PDFs, Scorm, etc.",
    "associateCourses": "Associar cursos na etapa",
    "associateTests": "Associar avaliações na etapa",
    "synopsis": "Forneça uma breve descrição, deixando claro o que será abordado no(a) {type} ou as partes mais importantes.",
    "detailsDescription": "Aqui você deve fornecer mais detalhes sobre os objetivos do(a) {type} para que o aluno possa visualizar claramente o que será coberto.",
    "inscriptionDate": "Dt. da Inscrição: {date}",
    "aiContext": "Habilite para fornecer um contexto descritivo que será usado para gerar representações vetoriais (embeddings), permitindo buscas semânticas mais precisas por IA.",
    expandImage: "Expandir imagem",
    recommended: {
      mediaCover: "Sugestão: Imagens com resolução {resolution}, ou superior, em proporção {aspect}. Tamanho máximo de {size}."
    },
    "profile": {
      "calledBy": "Preenchendo este campo, a plataforma o utilizará em toda a comunicação com você",
      skillsTitle: "Selecione até {limit} competências que gostaria de desenvolver.",
      skillsDescription: "Usaremos essas informações para sugerir conteúdos personalizados e relevantes para seu crescimento profissional.",
      "personalData": "Os campos de Email e Documento só podem ser alterados pela administração da plataforma ou pelo RH (quando integrado).",
      "corporateData": "Os dados desta seção são alterados pelo sistema de RH (quando integrado) ou gerente de conta e inscrições.",
      "academicData": "Digite aqui os dados relacionados ao seu percurso acadêmico e outros."
    },
    "originFilter": "Para visualizar ou filtrar conteúdo de distribuidores, selecione a opção 'Distribuidor' na coluna 'Origem'.",
    "export": "Habilitado, exportará todos os registros disponíveis. Desabilitado, exportará apenas os registros visíveis na tabela.",
    "contracts": {
      "aliareCode": "Este código é carregado automaticamente quando integrado à Plataforma Aliare.",
      "observation": "Digite aqui os detalhes específicos do contrato necessários para documentar negociações ou outras atividades.",
      "sectionField": "Neste campo, você pode vincular uma ou mais seções criadas pela Plantar e compartilhá-las com o contrato, tornando-as visíveis no aprendizado do cliente.",
      "communicationsField": "Neste campo, você pode vincular uma ou mais comunicações criadas pela Plantar e compartilhá-las com o contrato, tornando-as visíveis no aprendizado do cliente."
    },
    "units": {
      "activeAutomation": "Automação Ativa",
      "childUnit": "Unidades Filhas"
    },
    "departments": {
      "observation": "Você pode fornecer um texto aqui que auxilia os usuários sobre o departamento."
    },
    "jobsTitles": {
      "developSkills": "Ao fornecer competências, a plataforma sugerirá conteúdo que ajuda o usuário a adquirir conhecimentos relacionados a elas."
    },
    "users": {
      "supervisor": "Especifique o líder, gerente ou superior imediato do usuário.",
      "unit": "Especifique a unidade de negócios à qual o usuário está vinculado.",
      "permission": "Permissões definem as rotinas às quais o usuário pode acessar. Na lista, clique no menu Ações (Definir permissão)",
      "receiveEmail": "Ativado, define que os usuários receberam os e-mails das suas inscrições.",
      classification: 'Classificação que determina os painéis e relatórios BI: Aluno, Administrador ou Gestor',
      "evaluator": "Quando ativado, o usuário poderá corrigir avaliações que exigem correção manual."
    },
    "repository": {
      "summary": "Forneça um breve contexto sobre o conteúdo. O texto será apresentado ao aluno na criação de cursos, trilhas e locais de consumo.",
      "developSkills": "Que tal vincular competências que este objeto apoiará os alunos? Você pode selecionar uma ou mais competências, e a plataforma (se configurada) pode sugerir conteúdo para alunos ou posições com base nos objetivos de aprendizado do aluno e/ou gerente.",
      "duration": "Esta é a duração que encontramos no seu arquivo de mídia e será exibida ao usuário durante a reprodução. Se desejar, você pode editá-la ajustando o tempo.",
      "embedded": "Se ativado, o conteúdo será incorporado ao player da plataforma. Desativado, o usuário será redirecionado para o link externo.",
      "disableActions": "Esta ação não pode ser realizada com uma mídia compartilhada.",
      "qrcode": "Para ler esse código, você pode usar um app leitor de QR ou alguns apps de câmera no seu smartphone.",
      "downloadQrcode": "Download do QR Code",
      "shareQrcode": "Compartilhar QR Code"
    },
    "tests": {
      "diagnostic": "Tem como objetivo reunir informações sobre o conhecimento prévio, habilidades e competências dos alunos.",
      "reaction": "Tem como objetivo medir o nível de satisfação dos funcionários com o treinamento e sua percepção geral do processo.",
      "learning": "Tem como objetivo avaliar o conhecimento adquirido a partir do treinamento aplicado.",
      "applicability": "Tem como objetivo avaliar se o aluno aplicou o que aprendeu no processo de treinamento.",
      "result": "Tem como objetivo avaliar os resultados obtidos a partir do treinamento aplicado.",
      "testType": "Com base no tipo escolhido, serão apresentados modelos de pergunta e resposta.",
      "developSkills": "Ao fornecer competências, a plataforma pode sugerir testes que ajudam o usuário a adquirir conhecimentos relacionados a elas.",
      requiredScore: "Forneça a porcentagem mínima de acerto para o aluno ser aprovado no teste.",
      "newAttempt": "Especifique se o usuário pode ter novas tentativas para concluir o teste e as regras que serão aplicadas.",
      "numAttempt": "Especifique quantas tentativas o usuário terá para concluir o teste.",
      "maxQuestions": "Especifique o número máximo de perguntas que serão apresentadas ao usuário. Se houver mais que o número especificado, elas serão carregadas em tentativas subsequentes, se houver.",
      "displayAnswers": "Se marcado, mostra as respostas corretas e incorretas ao usuário após confirmar a opção selecionada.",
      "shuffleQuestions": "Permite embaralhar as perguntas no teste, saindo da ordem de inclusão.",
      "shuffleOptions": "Permite embaralhar as alternativas da pergunta, saindo da ordem de inclusão.",
      "showTimer": "Se ativado, mostra o cronômetro para o usuário no teste.",
      "duration": "Especifique o tempo que o usuário tem para concluir a avaliação, ou deixe em branco para não ter limite de tempo.",
      "typeQuestions": "Especifique o objetivo da sua pergunta escolhendo entre as opções abaixo.",
      "attachImage": "Permite vincular até 5 imagens para serem apresentadas ao usuário durante a avaliação.",
      "scale": "Permite ao aluno escolher um número em uma escala de 1 ao valor selecionado abaixo.",
      "customFeedback": "Permite incluir feedback a ser apresentado ao usuário após a correção da opção respondida.",
      "behavior": "A Avaliação de Comportamento é uma avaliação que acontece posterior à conclusão do curso/trilha. O prazo de envio será definida pelo seu gestor e você será notificado quando estiver disponível.",
      "submittingBehaviorAssessment": "Prazo para envio da Avaliação de Comportamento"
    },
    "courses": {
      "sequence": "Habilitado, define que o usuário precisa seguir a sequência da estrutura definida durante o consumo. Desabilitado, o usuário pode navegar livremente por qualquer conteúdo.",
      "duration": "Forneça a duração estimada em horas e minutos para o curso. Para calcular automaticamente os itens inseridos, basta clicar no botão esquerdo (calculadora).",
      "progress": "Especifique a porcentagem de progresso necessária para a geração do certificado (quando associado) e/ou para alcançar o status de conclusão.",
      "daysLimit": "Prazo máximo (em dias) para um aluno concluir o curso. Se definido como 0, não há controle de limite.",
      "mandatoryCompletion": "Define se o aluno precisa concluir o conteúdo dentro do prazo de conclusão.",
      "certificate": "O certificado pode ser vinculado a um curso. Uma vez inserido aqui, torna-se o padrão para o curso",
      "skills": "Que tal vincular competências que este objeto apoiará os alunos? Você pode selecionar uma ou mais competências, e a plataforma (se configurada) pode sugerir conteúdo para alunos ou posições com base nos objetivos de aprendizado do aluno e/ou gerente.",
      "challenges": "Que tal vincular desafios que este objeto apoiará os alunos? Você pode selecionar um ou mais desafios, e a plataforma (se configurada) pode sugerir conteúdo para alunos ou posições com base nos objetivos de aprendizado do aluno e/ou gerente.",
      "termOfUse": "Um termo de aceite pode ser específico para um curso e, quando associado, será exibido no final do conteúdo.",
      "sections": "Aqui você pode vincular o curso diretamente à seção já registrada. Ao fazer isso, o conteúdo já será apresentado no processo de aprendizado para o aluno."
    },
    "sections": {
      "typeSection": "Defina se a seção será de conteúdo (cursos, trilhas, mídias) ou será usada para comunicação (banner de imagem).",
      "environment": "A qual ambiente a seção pertence?",
      "useSegmentation": "Escolher vincular uma segmentação remove vínculos anteriores com unidades, departamentos e cargo.",
      "useDepartment": "Ao escolher vincular uma unidade, departamento ou cargo, segmentações anteriores serão desvinculadas automaticamente.",
      "useBoth": "Não é possível vincular segmentação e Departamento, Cargo e Unidade ao mesmo tempo.",
      "period": "Especifique o período de disponibilidade para a seção ou deixe em branco para exibi-la sempre.",
      "showDescription": "Se ativado, a descrição será exibida abaixo do título da seção na tela de aprendizado dos alunos. Caso contrário, permanecerá oculta.",
      "showInHome": "Mostrar na Página Inicial"
    },
    "challenges": {
      "completeWithin": "0 não tem prazo de conclusão"
    },
    "categories": {
      "types": "Tipo que irá definir em qual local a categoria será listada"
    },
    segmentations: {
      observation: "Insira observações",
      operator: "Restringe a segmentação ao contexto. \nOU: Para atender ao menos uma regra. \nE: Para exigir todas.",
      comparisonOperator: "Apliação aos critérios selecionados. \nIgual: Usuários que atendem todos os critérios selecionados. \nDiferente: Usuários que não atendem nenhum dos critérios selecionados.",
      selectValidate: "É necessário ao menos um vínculo na segmentação."
    },
    "certificates": {
      "tag": "Essas tags são substituídas automaticamente pelos valores indicados",
      "linkedin": "Aqui você cria uma nova publicação no Linkedin a partir do seu certificado",
      "profile": "Aqui você adiciona um novo certificado ao seu perfil, incluindo novas competências adquiridas, etc.",
      "unableCertificate": "Você ainda não alcançou as condições para receber o certificado",
      "emitCertificate": "Emitir certificado"
    },
    "permissions": {
      "select": "De acordo com o perfil desejado, marque em cada módulo as funcionalidades que os usuários vinculados a este grupo de permissão poderão ter acesso.",
      "validateSelect": "Você deve selecionar pelo menos uma permissão!"
    },
    "customizations": {
      "collapsedMenu": "A imagem será exibida no menu lateral recolhido da plataforma",
      "menuLogin": "A imagem será exibida no menu lateral e na página de login da plataforma",
      "pageIcon": "O ícone da página é geralmente exibido na guia do navegador",
      "previewChanges": "Visualize as alterações em tempo real no sistema"
    },
    "automated": {
      "forUsers": "Ativado, define que a automação será válida para usuários cadastrados a partir da data informada no campo seguinte. Obs: Se marcado, campo data será obrigatório",
      "forAll": "Ativado, define que a automação será válida para todos os usuários cadastrados, independe da data do seu cadastro.",
      "setDate": "Campo Data: Ao informar-lá será considerado para a inscrição, somente os cadastros de usuários maior ou igual à data informada",
      "notifyEmail": "Ativado, define que os usuários receberam os e-mails das suas inscrições."
    },
    "details": {
      "limitDays": "Limite de dias para conclusão",
      "requiredProgress": "Andamento requerido"
    },
    termsOfUse: {
      type: "O tipo \"Ambiente\" vincula-se aos parâmetros de acesso para aceite no primeiro acesso ou após alterações do mesmo. O tipo \"Aprendizado\" vincula-se a Cursos ou Trilhas, definindo critérios de aceite do conteúdo.",
      tags: "Para inserir uma tag, posicione o cursor no local desejado e selecione a tag. Consulte o menu Ajuda para mais informações.",
      displayIn: "Define se o \"Termo de Uso\" será exibido na introdução ou no encerramento do curso ou trilha."
    },
    "textDocument": "Documento de texto",
    "presentation": "Apresentação",
    "spreadsheet": "Planilha",
    "other": "Outros",
    "bookmark": "Favorito|Favoritos",
    "multipleContracts": "Aplica as configurações para multiplos contratos",
    journey: {
      required: "Define se o cartão da jornada apresentará a tag 'Obrigatório'",
      order: "Altere a ordem em que o conteúdo será disponibilizado",
      manualUsers: "Garante que os usuários selecionados sejam inscritos nesta jornada.",
      forAllCompany: "Se ativo, todos os usuários da plataforma serão inscritos automaticamente nesta jornada, inclusive os futuros usuários.",
      segmentation: "Define para qual segmento de usuários esta jornada será direcionada. Apenas usuários que fizerem parte do segmento selecionado poderão ser inscritos nesta jornada."
    }
  },
  "tabs": {
    "personalData": "Dados Pessoais",
    "corporateData": "Dados Corporativos",
    "academicData": "Dados Acadêmicos"
  },
  "modals": {
    "profile": "Meu perfil",
    "detailsDashboard": "Detalhes {title}",
    "select": "Selecionar",
    "associate": "Associando {title}",
    "details": "Detalhes",
    "adding": "Adicionando um {title} | Adicionando uma {title}",
    "editing": "Editando {title}",
    "insertImage": "Inserir imagem",
    "dissociate": "Desvincular {title}",
    "associateWith": "Associando {title} nos {type}",
    "inscriptions": "Inscrições {type} {title}",
    "newPassword": "Definir uma nova senha",
    "automated": "Jornadas automatizadas em {type} {title}",
    "previewCertificate": "Prévia do certificado",
    "sectionsOrder": "Definir ordenação das Seções",
    "associations": "Associações com o objeto {title}",
    "associationsCourses": "Associações com o curso {title}",
    "segmentationsUser": "Usuários Vinculados",
    "inscriptionsUser": "Inscrições do Aluno: {title}",
    "alterPermission": "Alterar permissão de {num} usuário selecionado | Alterar permissão de {num} usuários selecionados",
    "addQuestion": "Adicionar pergunta",
    "editQuestion": "Editar pergunta",
    "termAgreementTitle": "Termo de Aceite: {title}",
  },
  "validation": {
    "required": "Campo obrigatório",
    "invalidEmail": "E-mail inválido",
    "passwordMatch": "As senhas devem coincidir",
    "invalid": "Insira um {field} válido | Insira uma {field} válido",
    "basicCharacters": "Apenas letras, números e dois caracteres especiais (_-)",
    "max": "O campo não pode exceder {max} caracteres",
    "min": "O campo precisa ter pelo menos {min} caracteres",
    "range": "O valor deve estar entre {0} e {1}",
    "minDuration": "A duração deve ser de pelo menos 1 minuto.",
    "minQuestions": "É necessário inserir pelo menos uma pergunta para o usuário.",
    "nameUsed": "Já existe uma etapa com este nome",
    "selectOption": "Selecione pelo menos uma opção",
    "sameEmail": "O novo e-mail não pode ser igual ao anterior.",
    "equalsEmail": "Os e-mails devem ser iguais.",
    "fileSizeExceeds": "O tamanho do arquivo excede o sugerido para uma boa experiência de navegação. Anexar um arquivo com até {maxSize} {unit} de tamanho.",
    "maxValue": "O valor não pode ser maior que {max}.",
    "maxNote": "O valor da nota não pode ser maior que a nota maxima.",
    "maxSelected": "Máximo de {max} itens permitidos.",
    "maxAlternative": "A alternativa não pode exceder {max} caracteres.",
    "invalidRedirectUrl": "URL de redirecionamento inválida: apenas URLs que começam com https:// são permitidas.",
    "invalidDate": "A data de termino deve ser posterior a data de inicio",
    "minUsers": "O limite não pode ser menor que a quantidade de usuários ativos ({min})",
    "maxImages": "Limite máximo de {max} imagens alcançado."
  },
  "feedback": {
    "on": "Ativado",
    "off": "Desativado",
    "preparingDownload": "Preparando download...",
    "copyToClipboard": "Copiado para a área de transferência",
    "noResults": "Nenhum resultado encontrado",
    "quickCreate": "Quer cadastrar?",
    "noResultsSearch": "Não foram encontrados resultados para a pesquisa realizada.",
    "tweakFilters": "Experimente ajustar os filtros",
    "tweakFiltersOrSearch": "Experimente ajustar os filtros ou pesquisar por outro termo.",
    "externalLink": "O item associado a este objeto de aprendizagem é um link externo que redireciona para fora da plataforma. Ao clicar no botão abaixo, uma nova aba do navegador será aberta.",
    "expiredContent": "O conteúdo <strong>{title}</strong>, expirou em <strong>{date}</strong>",
    "emailSent": "E-mail enviado com sucesso!",
    "loading": "Carregando",
    "loadingSection": "Carregando seção...",
    "updating": "Atualizando",
    "pleaseWait": "Por favor aguarde",
    "processingRequest": "Processando solicitação",
    "processingMediaTitle": "Processando seu arquivo",
    "processingMediaText": "Isso pode levar alguns instantes. Enquanto isso, o vídeo não pode ser visualizado.",
    "processingFileTitle": "Estamos processando seu arquivo",
    "processingFileText": "Isso pode levar alguns instantes. Enquanto isso, não é possível removê-lo ou alterar o tipo de objeto.",
    "mediaNotFound": "O arquivo da mídia não foi encontrado. Talvez o upload ainda não tenha sido concluído, ou foi interrompido.",
    "loadingAchievements": "Carregando conquistas...",
    "loadingRanking": "Carregando ranking...",
    "noFound": "Nenhum item encontrado",
    "resourceUnavailable": "Ops! Este item não está mais disponível para visualização nesta conta. Se precisar de ajuda ou tiver alguma dúvida, entre em contato com o suporte ou contate o responsável pela plataforma.",
    "changeCompany": "Não é possível mudar a empresa do contrato!",
    "formError": "Verifique o(s) erro(s) no formulário",
    "errorLoadObject": "Não foi possível carregar as informações do {object}! Recarregue a página e tente novamente.",
    "successRequest": "Solicitação(ões) enviada(s) com sucesso!",
    "success": "Sucesso",
    "error": "Erro",
    "attention": "Atenção!",
    suggestedSize: 'Tamanho sugerido: {width}px x {height}px',
    "failedRequest": "Falha ao enviar a solicitação",
    "errorRequest": "Não foi possível enviar a(s) solicitação(ões)",
    "wait": "Espere!",
    "validationFailed": "Falha na validação",
    "formatInvalid": "Formato não suportado para visualização",
    "failedLoadInfo": "Falha ao carregar informações",
    "processingData": "Processando dados...",
    "await": "Aguarde...",
    "loadingTest": "Carregando informações da avaliação...",
    "somethingWrong": "Opa... Algo deu errado",
    "failedLoadItems": "Erro ao carregar os itens",
    "retryMessage": "Tente novamente em alguns instantes.",
    "loadingObjects": "Carregando {object}",
    "connectionFail": "Parece que não foi possível reestabelecer a comunicação com o serviço. Por favor tente novamente em alguns instantes.",
    "userNotFound": "Não foi possível identificar o usuário, recomendados atualizar a página!",
    "noPermissionResource": "Você não tem permissão para gerenciar este recurso",
    "successRequestPassword": "Solicitação enviada com sucesso!",
    "loadingCustomization": "Aguarde... Carregando configurações do sistema",
    "futureBirthday": "A data de nascimento não pode ser uma data futura",
    "searchPlaceholder": "O que você procura?",
    "searchInitFeedback": "Explore os conteúdos disponíveis na plataforma: busque entre mídias, cursos e trilhas para encontrar o que melhor atende às suas necessidades de aprendizado.",
    "navigate": "Navegar",
    "select": "Selecionar",
    "close": "Fechar",
    "recordedResponse": "Sua resposta foi registrada!",
    "updateAvailable": "Atualização Disponível!",
    "updateAvailableMessage": "Uma nova versão do sistema está disponível! Clique aqui ou recarregue a página para aplicar as atualizações.",
    "limitReached": "Limite de {limit} item(ns) atingido",
    loginSettingsAccess: {
      title: "Conheça nossa nova tela de login!",
      message: "Estamos fazendo alguns ajustes finais, mas você já pode experimentar a nova interface. Para acessá-la, clique no botão abaixo e veja as novidades.",
    },
    "feedbackQuestion": "Em breve, você receberá um feedback sobre a sua resposta. Agradecemos o seu empenho na realização da prova.",
    "suggestionTitle": "Sugestão de Conteúdo",
    "suggestionSent": "Sugestão enviada com sucesso!",
    "suggestionSentMessage": "Obrigado por sua sugestão! Nós valorizamos seu feedback.",
    cantReact: "Você só pode reagir ao conteúdo após a conclusão.",
    "inactiveCertificate": "Não é possível inativar um certificado vinculado a um curso ou trilha.",
    "finishAssessment": "A avaliação foi finalizada com sucesso",
    "manualCorrection": "Esta questão requer avaliação manual.",
    "questionTypeNotSupported": "Tipo de questão não suportado!",
    "noOptions": "Nenhuma opção disponível",
    "errorLoadingAssessment": "Erro ao carregar avaliação",
    "successCorrection": "A correção foi salva com sucesso",
    "attentionResponse": "Responda com atenção!",
    "attentionResponseMessage": "Uma resposta incorreta irá anular os pontos de uma resposta correta selecionada.</br> Certifique-se de revisar suas escolhas cuidadosamente antes de prosseguir.",
    "uploadAllowed": "Essa questão permite envio de arquivos para correção",
    "noAlternatives": "Erro ao carregar as alternativas, tente novamente ou contate o suporte",
    "durationOject": "A duração do objeto refere-se ao tempo necessário para consumir o conteúdo.",
    "errorLoadingObject": "Erro ao carregar...",
    "assessmentNotFound": "Avaliação não encontrada, ou mal formada.",
    assessmentEvaluatorAssigned: "Avaliadores atribuídos com sucesso!",
    noAvailableAssessment: "Nenhuma avaliação elegível",
    noAvailableQuestion: "Nenhuma das avaliações selecionadas possui questões que exigem examinadores.",
    noAvailableExaminer: "Nenhum examinador necessário",
    noRequiredExaminer: "Esta avaliação não possui questões dissertativas ou práticas, portanto não é necessário atribuir examinadores.",
    pleaseSetScore: "Por favor, informe a nota da correção na questão em destaque",
    "invalidDuration": "Formato de duração inválido. Use o formato HH:MM:SS com valores válidos até 23:59:59.",
    dragImageHere: "Arraste uma imagem aqui",
    orClickToBrowse: "ou clique para selecionar",
    sections: {
      top10Limit: "Não é possível selecionar mais items para o Top 10",
      top10HelpTitle: "Defina os critérios para exibir a seção Top 10.",
      top10HelpDescription: "A lista é atualizada diariamente com base no critério e no período selecionados, exceto no critério **Manual**.",
      top10CriteriaExample: "**Exemplo:** se você escolher o critério **Inscrições** e o período **Mensal**, todos os dias à meia-noite o sistema irá recalcular o Top 10 considerando as inscrições realizadas nos últimos 30 dias, a partir da data de execução.",
      releasesHelpTitle: "Defina os critérios para exibir a seção Lançamentos.",
      releasesHelpDescription: "A lista é atualizada diariamente com base no critério e no período selecionados, exceto no critério **Manual**.",
      releasesCriteriaExample: "**Exemplo:** se você escolher o critério **Data Criação** e o período **Mensal**, todos os dias à meia-noite o sistema irá recalcular os lançamentos considerando a data de criação realizadas nos últimos 30 dias, a partir da data de execução."
    },
    "noCredential": "Nenhuma credencial informada.",
    profileImageSuccess: "Imagem de perfil enviada com sucesso!",
    errorLoadingFile: "Ocorreu um erro ao processar o arquivo. Por favor envie novamente!"
  },
  "login": {
    "welcome": "Bem-vindo!",
    "forgotPasswordTitle": "Digite seu e-mail de login para que possamos enviar o link de redefinição de senha.",
    returnLogin: "Voltar ao Login",
    "sendEmail": "Enviar",
    "forgotPassword": "Esqueceu sua senha?",
    "helpNeeded": "Precisa de ajuda para fazer login?",
    "talkToUs": "Fale Conosco",
    "rememberMe": "Manter conectado",
    "passwordPlaceholder": "Digite sua senha",
    "emailPlaceholder": "Digite seu e-mail",
    certificateValidation: "Validação de Certificado",
    "userFound": "Usuário encontrado...",
    "sessionData": "Registrando dados da sessão.",
    "loginWith": "Continuar com",
    "authenticated": "Usuário autenticado com sucesso!",
    "loadingInformation": "Carregando informações adicionais",
    "accountInformation": "Informações da Conta",
    "userData": "Dados do Usuário",
    "userPermissions": "Permissões do Usuário",
    enterCompanyName: "Informe o nome da empresa",
    enterTheProvider: "Informe a empresa cadastrado na plataforma",
    "recaptchaHint": "Por segurança, confirme que você não é um robô para continuar."
  },
  "twoFactor": {
    "title": "Verificação em duas etapas",
    "sentByEmail": "Para confirmar que é você, enviamos um código de {length} dígitos para",
    "sentBySms": "Para confirmar que é você, enviamos um código de {length} dígitos por SMS para",
    "codeLabel": "Código de verificação",
    "digitLabel": "Dígito {position} de {total}",
    "verify": "Verificar e entrar",
    "expiresIn": "O código expira em {time}",
    "expired": "O código expirou. Solicite um novo para continuar.",
    "lockedFor": "Muitas tentativas. Tente novamente em {time}",
    "resend": "Reenviar código",
    "resendIn": "Reenviar código em {seconds}s",
    "resent": "Enviamos um novo código.",
    "backToLogin": "Voltar ao login",
    "genericError": "Não foi possível validar o código. Tente novamente."
  },
  "recover": {
    "title": "Esqueceu sua senha?",
    "hintTitle": "Digite seu e-mail cadastrado na Plataforma.",
    "hintBody": "Vamos enviar um link para redefinir sua senha.",
    "submited": "Assim que acessar o link enviado para o e-mail <strong>{email}</strong>, você será redirecionado para a página de redefinição de senha.",
    "submitedInstructions": "Você receberá em breve um e-mail com o link para redefinir sua senha."
  },
  "newPassword": {
    "title": "Defina sua nova senha",
    "hintTitle": "Digite sua nova senha.",
    "subtitle": "É necessário definir uma nova senha para acessar a plataforma.",
    "hintBody": "Agora você pode acessar a Plataforma com sua nova senha.",
    "rulesText": "Sua Nova Senha deve ter",
    "recoverAgain": "Redefinir Senha Novamente",
    "expired": {
      "title": "Token Inválido/Expirado",
      "msg": "O token de ativação é inválido ou não mais válido. Por favor, solicite uma nova recuperação de senha ou entre em contato com o suporte."
    },
    "success": {
      "title": "Senha redefinida com sucesso!",
      "msg": "Agora você pode acessar sua conta novamente."
    },
    "redirectionMsg": "Você será redirecionado para a tela de Acesso à Plataforma em alguns segundos.",
    "rules": {
      "length": "Mínimo de 8 e máximo de 32 caracteres",
      "ascii": "Apenas caracteres ASCII (sem espaços, acentos, cedilha ou emoji)",
      "noRepeats": "Sem o mesmo caractere repetido em sequência (ex.: aa, 11)",
      "hasUniqueChar": "Pelo menos um caractere que apareça apenas uma vez",
      "hasUppercase": "Um caractere de texto maiúsculo (ABC)",
      "hasLowercase": "Um caractere de texto minúsculo (abc)",
      "case": "Pelo menos uma letra maiúscula",
      "hasNumbers": "Um caractere numérico (123)",
      "hasSpecialChars": "Um caractere especial (-, {'@'}, *, #, etc.)",
      "match": "As duas senhas devem ser iguais"
    },
    "validation": {
      "minMax": "A senha deve ter entre {min} e {max} caracteres.",
      "ascii": "A senha deve conter apenas caracteres ASCII, sem espaços, acentos, cedilha ou emoji.",
      "noRepeats": "A senha não pode conter o mesmo caractere repetido em sequência.",
      "uniqueChar": "A senha deve conter pelo menos 1 caractere que apareça apenas uma vez.",
      "uppercase": "A senha deve conter pelo menos 1 letra maiúscula.",
      "lowercase": "A senha deve conter pelo menos 1 letra minúscula.",
      "case": "A senha deve conter pelo menos 1 letra maiúscula.",
      "numbers": "A senha deve conter pelo menos 1 caractere numérico.",
      "specialChars": "A senha deve conter pelo menos 1 caractere especial."
    },
    "batch": {
      "selectedUsers": "Usuários selecionados",
      "passwordWillBeChanged": "A senha será alterada para todos os usuários selecionados",
      "noUsersSelected": "Nenhum usuário selecionado",
      "changePasswordOnNextAccess": "Alterar senha no próximo acesso"
    },
    "error": {
      "title": "Erro ao redefinir senha",
      "msg": "Ocorreu um erro ao redefinir sua senha. Por favor, tente novamente em alguns instantes."
    }
  },
  "alerts": {
    "youIncredible": "Você é incrível!",
    "noNotifications": "Por enquanto, nenhuma nova notificação. Aproveite seus estudos!",
    "dashboardError": "Ocorreu um erro ao recuperar os dados do painel. Por favor, tente novamente em alguns minutos.",
    "canCreateUsers": "Seu contrato atingiu o número máximo de usuários ativos! Por favor, entre em contato com o suporte.",
    "loadingPartners": "Carregando os parceiros, aguarde um momento.",
    "errorLoadPartners": "Não foi possível carregar os parceiros vinculados à sua conta, tente novamente em alguns instantes.",
    "resubscribe": "Caso clique no botão <strong>Reinscrever</strong>, você perderá seu conteúdo já concluído! <br>Para mais informações, contate seu gestor ou o suporte da plataforma",
    "scrollTermsOfUse": "O botão Aceitar será habilitado quando você rolar o conteúdo até o final.",
    "document": "Neste passo, é necessário um arquivo complementar. Clique no botão abaixo para realizar o download.",
    "errorMediaTitle": "Erro ao buscar informações da midia",
    "errorMediaMessage": "Houve um erro ao tentar carregar informações da midia. Tente fechar e abrir novamente.",
    "termOfUse": "Este termo de uso está vinculado aos parâmetros e sua estrutura não pode ser alterada.",
    "errorBiContent": "Houve um erro ao tentar carregar informações do Painel selecionado. Tente novamente ou verifique se as informações cadastradas do Painel estão corretas",
    errorTermsOfUse: "Não foi possível carregar os Termos de Uso. Tente novamente em alguns instantes.",
    "blockPlayer": "Caso ativo bloqueia no player, as ações de aumentar a velocidade de reprodução e avançar o progresso para um tempo ainda não assistido",
    limitExceeded: "Limite máximo de {max} itens atingido. Você tem atualmente {count} itens.",
    distributorOrigin: "Esse item é de origem do distribuidor, portanto não pode ser editado. Você pode apenas visualizar as informações.",
    journey: {
      generalRules: "Nesta etapa você pode definir as principais regras de cadastro e envio da jornada automatizada. Fique de olho nos ícones de ajuda se tiver alguma dúvida."
    }
  },
  "language": {
    "set": "Definir idioma",
    "change": "Mudar idioma"
  },
  "notifications": {
    "activityHistory": "Histórico de Atividades",
    "alertEnable": "Clique no botão abaixo para permitir notificações em seu navegador.",
    "enable": "Habilitar notificações",
    "unsupportedTitle": "Notificações instantâneas desativadas!",
    "unsupportedBody": "Seu navegador não suporta notificações ou elas estão desativadas.",
    "history": "Histórico de Notificações",
    "uploadHistory": "Histórico de Envios",
    "unread": "Apenas não visualizadas",
    "markSelectionRead": "Marcar selecionados como lido",
    "successBulkReplication": "Configurações replicadas com sucesso",
    "errorBulkReplication": "Ocorreu um erro ao replicar as configurações. Por favor, tente novamente em alguns instantes. Erro: {error}",
    "uploadingFiles": "Iniciando upload dos arquivos...",
    "uploadCompleted": "Upload concluído com sucesso.",
    "bulkReplicationInit": "Iniciando replicação de plano de fundo e banner em massa..."
  },
  "menu": {
    "home": "Início",
    "catalog": "Catálogo",
    "favorites": "Meus Favoritos",
    "expandMenu": "Expandir Menu",
    "collapseMenu": "Contrair Menu",
    "learning": "Aprendizado",
    "management": "Gestão",
    "myProgress": "Meu Progresso",
    "myGames": "Minhas Competições",
    "competitions": "Competições",
    "dashboard": "Dashboards",
    "myPanel": "Meu Painel",
    "bi": "BI",
    "externalCertificates": "Certificados Externos",
    "accounts": "Contas",
    "companies": "Empresas",
    "contracts": "Contratos",
    "units": "Unidades",
    "departments": "Departamentos",
    "jobsTitles": "Cargos",
    "users": "Usuários",
    "content": "Conteúdo",
    "repository": "Depósito",
    "tests": "Avaliações",
    "courses": "Cursos",
    "trails": "Trilhas",
    "sections": "Seções",
    "manageExternalCertificates": "Gerir Certificados Externos",
    "communications": "Comunicações",
    "communication": "Comunicação",
    "automatedNotifications": "Notificações Automatizadas",
    "gamification": "Gamificação",
    "journey": "Jornada",
    "challenges": "Desafios",
    "settings": "Configurações",
    "customizations": "Personalizações",
    "skills": "Competências",
    "permissions": "Permissões",
    "categories": "Categorias",
    "certificates": "Certificados",
    "termsOfUse": "Termos de Uso",
    "segmentations": "Segmentações",
    "rules": "Regras",
    "myContract": "Meu Contrato",
    "notificationHistory": "Histórico de Notificações",
    "uploadHistory": "Histórico de Uploads",
    "notifications": "Notificações",
    biPanels: "Painel BI|Painéis BI",
    biPanelsAndReports: "Painéis e Relatórios BI",
    biManagement: "Gestão BI",
    "importHistory": "Histórico de Importações",
    'wellBeingIndicator': 'Indicadores de Bem-estar',
    smtpConfiguration: "Configuração SMTP",
    myJourney: 'Minha Jornada|Minhas Jornadas',
    learningJourney: 'Jornada de Aprendizagem|Jornadas de Aprendizagem',
    reports: 'Relatórios'
  },
  "topbar": {
    profile: "Perfil",
    settings: "Configurações",
    termsAndConditions: "Termos e condições",
    changeCompany: "Mudar empresa",
    logout: "Sair"
  },
  "mainContent": {
    "sections": {
      "keepLearning": "Continue Aprendendo",
      "suggestedForYou": "Sugeridos Para Você",
      "seeAgain": "Ver Novamente",
      "seeAgainDescription": "Reviva os conteúdos que você já acessou e aprofunde seu aprendizado.",
      "favorites": "Seus favoritos serão vistos aqui! <br> Para favoritar, basta marcar o ícone no canto superior presente no conteúdo",
      "noFound": "Não localizamos nenhum resultado em <strong>{text}!</strong> O que acha de tentar novos filtros ou mudar de aba?",
      "startLearning": "Que tal começar sua jornada de aprendizado? <strong>Clique aqui</strong> e encontre o conteúdo ideal para você!",
      "emptySection": "Você não tem nenhuma seção ativa.<br>Comece agora mesmo a inserir<br>conteúdos!Clique aqui!<br>",
      "keepLearningDescription": "Continue de onde parou! Aqui estão os cursos, trilhas e mídias que você começou ou acabou de se inscrever. Mantenha seu ritmo de aprendizado e avance na sua jornada de desenvolvimento.",
      "suggestedForYouDescription": "Recomendamos conteúdos alinhados às competências do seu cargo ou perfil. Explore cursos, trilhas e mídias pensadas para impulsionar seu crescimento profissional."
    },
    "export": {
      "moveColumns": "Mover todas as colunas?",
      "columnsExported": "Colunas a serem exportadas",
      "dragColumns": "Arraste as colunas aqui",
      "exportAll": "Exportar todos os dados?",
      "help": "Arraste todas as colunas disponíveis que você deseja exportar para a área 'Colunas a serem exportadas' à direita.",
      "availableColumns": "Colunas disponíveis",
      "removeColumns": "Remover todas as colunas"
    },
    "units": {
      "addChild": "Adicionar Unidade Filha",
      "helpTitle": "Crie sua estrutura organizacional!",
      "createOther": "Você pode criar outras <strong>unidades</strong> dentro de uma já existente.",
      "justClick": "Basta Clicar",
      "orCreate": "ou criar uma nova estrutura na raiz clicando"
    },
    "users": {
      "import": {
        "alerts": {
          "initial": {
            "title": "Orientações para Importação em Lote",
            "message": "Para importação em lote, o arquivo deve estar no formato .xls ou .xlsx. Para prosseguir com a importação, você precisa baixar o arquivo modelo, preenchê-lo e enviar."
          },
          "valid": {
            "title": "O arquivo foi validado com sucesso!",
            "message": "Clique em 'importar dados' para concluir o agendamento da importação."
          },
          "finish": {
            "title": "Seus dados foram agendados com sucesso!",
            "message": "Os dados estão agendados para importação. Por favor, verifique a lista de usuários após 10 minutos para acompanhar o progresso."
          },
          "processing": {
            "title": "Validando seu arquivo!",
            "message": "Selecione os parâmetros e clique em 'Importar Dados' para concluir."
          },
          "failed": {
            "title": "Não conseguimos validar seu arquivo! Verifique se é do tamanho e formato corretos, e tente novamente.",
            "message": "Para mais detalhes sobre a importação"
          }
        },
        "feedback": {
          "initial": {
            "title": "Importe seus dados facilmente",
            "message": "O registro em lote oferece mais conveniência e rapidez para você, permitindo a importação de dados para diferentes pessoas ao mesmo tempo."
          },
          "processing": {
            "title": "Estamos validando seu arquivo...",
            "message": "Esta etapa é para garantir que tudo esteja correto com o arquivo antes de ser importado."
          },
          "failed": {
            "title": "Resumo da Importação"
          },
          "start": {
            "title": "A importação está em andamento...",
            "message": "A importação será concluída em breve."
          }
        },
        "importTemplate": "Não tem o modelo para importar usuários em lote?",
        "download": "Baixar modelo",
        "log": "Baixar o log",
        "dragdrop": "Arraste e solte o arquivo .xls / .xlsx aqui ou",
        "consultTitle": "Consulta do Lote de Importação de Usuários",
        "consultLabel": "ID do Lote (FileId / BatchId):",
        "consultPlaceholder": "Cole aqui o ID do lote",
        "consultNotFound": "Nenhum lote de importação encontrado para o ID informado.",
        "itemsList": "Detalhamento por Usuário",
        "noItemsDetails": "O lote está em processamento ou não possui detalhamento de itens no momento."
      },
      "updateEmail": "Atualização do E-mail",
      "triggerEmail": "Dispara e-mail da inscrição"
    },
    "inscriptions": {
      "import": {
        "feedback": {
          "initial": {
            "message": "O registro em lote oferece mais conveniência e rapidez para você, permitindo a importação de dados para diferentes inscrições ao mesmo tempo."
          },
        },
        "importTemplate": "Não tem o modelo para importar inscrições em lote?",
      },
    },
    "repository": {
      "dragDrop": "Selecione ou arraste um arquivo para esta área.<br><br> Considerando a experiência do usuário ao assistir a vídeos, recomendamos que seus arquivos não ultrapassem um tamanho de 1 GB.",
      "generateQr": "Gerar QR Code",
      "insertLink": "Insira o Link"
    },
    "automatedNotifications": {
      "events": {
        "notAccessEnvironment": "Não acessou a plataforma durante um período de dias definido",
        "notStartedCourseOrTrail": "Não iniciou o curso e trilha durante um período de dias definido",
        "expireCourseOrTrail": "Vencimento de curso e trilha próximo a expirar",
      },
      "sendingInterval": {
        "once": "Apenas uma única vez",
        "day": "Uma vez por dia",
        "week": "Uma vez por semana",
        "month": "Uma vez por mês"
      },
      template: {
        notAccessEnvironment: `<p>Percebemos que faz um tempo desde a sua última visita à nossa plataforma. Sabemos o quanto é importante manter-se atualizado e em constante aprendizado.</p><p></p><p>Estamos aqui para lembrar que temos uma grande variedade de cursos e trilhas disponíveis para ajudar no seu crescimento profissional.</p><p>Aproveite para explorar novos conteúdos e continuar a sua jornada de aprendizado.</p><p></p><p>Esperamos vê-lo novamente em breve!</p>`,
        notStartedCourse: `<p>Queremos incentivá-lo a iniciar seu aprendizado com o conteúdo que está disponível para você em nossa plataforma.</p><p></p><p>Gostaríamos de lembrá-lo(a) de que você possui inscrições pendentes.</p><p></p><p>Acesse a plataforma e dê o primeiro passo em sua jornada de conhecimento!</p>`,
        expireCourse: `<p>Esperamos que esteja aproveitando seu aprendizado conosco!</p><p></p><p>Gostaríamos de lembrá-lo(a) de que o prazo de vencimento do seu conteúdo está se aproximando.</p><p></p><p>Aproveite este momento para concluir seus estudos dentro do prazo estabelecido e continue investindo em seu desenvolvimento profissional.</p>`
      },
      "subject": {
        "notAccessEnvironment": "Sentimos sua falta! Volte para a plataforma e continue aprendendo",
        "notStartedCourse": "Não perca a chance de aprender! Comece seu curso/trilha agora",
        "expireCourse": "Lembrete: Seu curso/trilha está quase no fim"
      },
      "needHelp": "<strong>Precisa de ajuda?</strong> Nosso time de suporte está pronto para te apoiar, basta clicar no ícone de ajuda.",
      "previewFooter": "Este é um e-mail automático enviado por Plantar Educação | www.plantareducacao.com.br",
      "tags": {
        "typeContent": "Tipo do conteúdo",
        "limitDate": "Data de vencimento do curso/trilha",
        "unit": "Nome da unidade de negócio do usuário",
        "department": "Nome do departamento do usuário",
        "jobTitle": "Cargo do usuário",
        "dateTime": "Data e hora do sistema",
      }
    },
    "challenges": {
      "environment": "Em qual ambiente será aplicado o desafio?",
      "typeContent": "Para qual tipo de conteúdo?"
    },
    "certificates": {
      "student": "Nome do aluno",
      "cpf": "CPF do aluno",
      "jobTitle": "Cargo do aluno",
      "content": "Nome do curso/trilha",
      "credential": "Código Credencial",
      "completed": "Data que o curso/trilha foi finalizado",
      "init": "Data que o curso/trilha foi iniciado",
      "duration": "Quantidade de horas do curso/trilha",
      "certificateId": "Identificador único do certificado",
      "newContent": "Novo Conteúdo",
      "objectiveCompleted": "<p><strong>Parabéns!</strong> Você completou os objetivos e merece esse certificado!</p><p>Você pode visualizar e baixar seu certificado clicando no botão abaixo!</p>",
      "certificateCompletion": "Certificado de conclusão",
      "sentTestTitle": "Obrigado! Sua avaliação foi recebida!",
      "sentTestMessage": "Sua opinião é muito importante para melhorarmos continuamente.",
      "completedProgress": "Você atingiu o andamento e/ou aproveitamento necessário para este conteúdo",
      "canReturn": "Você pode retornar e revisar sempre que quiser utilizando também a área de",
      "searchContent": "ou buscar novos conteúdos acessando o ambiente",
      "generateNow": "O que acha de gerar seu certificado agora mesmo",
      "notAccept": "Para gerar o certificado é necessário aceitar os termos de aceite.",
      forceUppercase: "Forçar letras maiúsculas",
      upperCaseHint: "Utilize tags em letras maiúsculas caso deseje que o conteúdo substituído mantenha esse formato.",
      editCertificate: "Editar Certificado",
      newCertificate: "Novo Certificado",
      loadingData: "Carregando dados do certificado...",
      generalSettings: "Configurações Gerais",
      certificateDesign: "Design do Certificado",
      cancelConfirmation: "Deseja realmente cancelar? As alterações não salvas serão perdidas.",
      successSaved: "Certificado salvo com sucesso."
    },
    "customizations": {
      "homePage": "Exibir na Página Inicial",
      "collapsedMenu": "Menu Contraído",
      "menuLogin": "Menu e Login",
      "generalSettings": "Configurações Gerais",
      "defaultCertificate": "Certificado Padrão",
      "logoutAddress": "Endereço de Logout",
      "policyAdress": "Endereço da Política de Privacidade",
      "backgroundImage": "Imagem de Fundo(s)",
      "boxPosition": "Posição da Caixa",
      "logos": "Logos e Favicon",
      "pageTitle": "Título e Descrição da Página",
      "integrations": "Integrações",
      "newScript": "Novo Script",
      "downloadPdf": "Permitir download de documentos PDF",
      "addWatermark": "Adicionar marca d'água aos documentos PDF",
      "menuLogoText": "Insira a imagem para o logotipo do menu interno no formato .JPG ou .PNG. Recomendamos imagens com as dimensões de <strong>90 x 60</strong> pixels. Anexe um arquivo de até <strong>100 kb</strong> de tamanho.",
      "loginLogoText": "Insira a imagem para o login externo no formato .JPG ou .PNG. Recomendamos imagens com as dimensões de <strong>150 x 150</strong> pixels. Anexe um arquivo de até <strong>100 kb</strong> de tamanho.",
      "logo": "Logo <strong>{type}</strong>",
      "pageIconHelp": "Insira a imagem para o ícone da página no formato .PNG para preservar a transparência do fundo. Recomendamos imagens com as dimensões de <strong>48 x 48</strong> pixels. Anexe um arquivo de até <strong>100 kb</strong> de tamanho.",
      "pageIcon": "Ícone da Página",
      "internalBanners": "Banners Internos",
      clickToAssciateCertificateCourse: "Clique para associar um certificado ao curso",
      clickToAssciateCertificateTrail: "Clique para associar um certificado à trilha",
      bannerLearning: "Banner da Página de Aprendizado",
      bannerPublicAlert: "Este banner foi enviado por um distribuidor, portanto apenas usuários com acesso de distribuidor podem alterá-lo.",
      "bannerLogin": "Imagem de Fundo da Tela de Login",
      "bannerNewTab": "Abrir link em nova aba?",
      login: {
        title: "Configurações da Página de Login",
        position: "Posição da Caixa de Login",
        newCarousel: "Novo Carrossel",
        carouselPublicAlert: "Este carrossel foi enviado por um distribuidor, portanto apenas usuários com acesso de distribuidor podem alterá-lo.",
        mediaUpload: "Upload de Mídia",
        removeCarousel: {
          title: "Você realmente deseja excluir este item?",
          message: "Essa ação é irreversível e o item será removido permanentemente. Se preferir, você pode optar por desativá-lo em vez de excluí-lo."
        },
        subtitle: "Tela de Login",
      },
      "hideDescriptionSection": "Ocultar descrição das seções padrões",
      "hideDescriptionSectionMessage": "Essa opção irá ocultar a descrição das seções Continue Aprendendo e Sugeridos Para Você",
      "theme": {
        "plataformTheme": "Tema da Plataforma",
        "defaultTheme": "Tema Padrão",
        "initialTheme": "Tema De Inicialização",
        "defaultThemeMessage": "Define o comportamento padrão do tema da plataforma.<br><ul><li><strong>Claro:</strong> sempre usa o tema claro.</li><li><strong>Escuro:</strong> sempre usa o tema escuro.</li><li><strong>Definido pelo Usuário:</strong> permite que o usuário altere o tema a qualquer momento.</li></ul>",
        "initialThemeMessage": "Define qual tema será usado na primeira vez que o usuário acessar a plataforma, antes de escolher uma preferência própria.",
        "blockTheme": "O modo de exibição {theme} foi definido pelo administrador e não pode ser alterado."
      }
    },
    "cookies": {
      "title": "Consentimento de Cookies",
      "content": "Utilizamos cookies e tecnologias semelhantes para melhorar a sua experiência, de acordo com as nossas",
      "continue": "Ao continuar navegando, você concorda com estas condições."
    },
    "partner": {
      "access": "Qual empresa deseja acessar?",
      "notSeeAgain": "Não desejo ver esta tela novamente!",
      "currentCompany": "Empresa Atual",
      "otherCompanies": "Outras Empresas",
      "loadList": "Aguarde um instante enquanto carregamos as empresas vinculadas à sua conta.",
      "search": "A busca por \"{text}\" não obteve resultados.",
      "differentTerms": "Experimente pesquisar com termos diferentes. Se precisar de assistência, entre em contato com nosso suporte.",
      "loadingOrganization": "Carregando os dados da organização",
      "defaultCompany": "Esta é minha empresa padrão"
    },
    "notAllowed": {
      "restrictedArea": "Área Restrita!",
      "noPermission": "Você não possui as devidas permissões para acessar esta página."
    },
    "notFound": {
      "title": "Página não encontrada!",
      "content": "A página que você tentou entrar talvez não exista ou foi movida."
    },
    "learning": {
      "banner": "Que tal inserir um banner aqui?<br>Clique para acessar as configurações!"
    },
    "classRoom": {
      "exitClassRoom": "Sair da sala de aula",
      "unavailableContent": "Conteúdo indisponível",
      "unavailableTemporaryContent": "Conteúdo indisponível temporariamente",
      "expired": "O tempo para realização do seu conteúdo expirou no dia: <strong>{date}</strong>",
      "contactNewSubscribe": "Contate seu gestor ou o suporte da plataforma para solicitar uma nova inscrição",
      "testInfo": "Informações sobre avaliação",
      "navigateQuestions": "Navegar pelas questões",
      "remainingQuestions": "Questões restantes",
      "timeOver": "<div>O tempo definido para realização desta avaliação acabou!</div><div>O cálculo para a sua aprovação ou reprovação será baseado nas respostas enviadas.</div>",
      "testTips": "Separamos algumas dicas para você realizar sua avaliação sem problemas",
      "tips": "<li>Fique atento ao tempo de duração caso a avaliação possua um limite de tempo</li><li>Sua resposta só será enviada quando você clicar em Enviar Resposta</li><li>Após enviada a resposta você não conseguirá alterar a alternativa selecionada</li>",
      "reactionTestTips": "<li>Sua resposta só será enviada quando você clicar em Enviar Resposta</li><li>Após enviada a resposta você não conseguirá alterar a alternativa selecionada</li><li>Após finalizado ou sair da avaliação, não poderá entrar e fazer novamente</li>",
      "completedItems": "itens concluídos",
      "approved": "Você foi aprovado",
      "disapproved": "Você não atingiu a nota necessária",
      "pendingCorrection": "Parabéns por concluir sua avaliação! 🎉",
      "pendingCorrectionInformation": "Agora, suas respostas serão enviadas para correção de um avaliador, que analisará as questões práticas ou dissertativas para registrar sua nota final.</br></br>Assim que a correção for concluída, sua nota será liberada. Caso sua avaliação esteja vinculada a um certificado, ele será disponibilizado após essa etapa.</br></br>Obrigado pela sua dedicação e bons estudos! 😊"
    },
    "externalCertificates": {
      "approved": {
        "title": "Sua solicitação foi aprovada",
        "message": "Seu curso já foi aprovado e registrado"
      },
      "denied": {
        "title": "Sua solicitação foi negada",
        "denyPosition": "O certificado não é valido para a posição ocupada",
        "denyInvalid": "O certificado informado é inválido",
        "denyIllegible": "O certificado informado é ilegível",
        "denyOther": "O certificado informado foi negado, consulte o motivo abaixo",
        "help": "Você pode tentar editar o certificado e enviar novamente para aprovação"
      },
      "pending": {
        "title": "Pendente",
        "message": "Aguardando validação e aprovação"
      },
      "incompatibleRole": "Incompatível com a função",
      "invalidCertificate": "Certificado inválido",
      "illegibleCertificate": "Certificado ilegível",
      "approvalRequest": "Solicitação de aprovação: {title}",
      "denyReason": "Informe o motivo da negação",
      "addCertificate": "Adicione seu certificado",
      "dropFile": "<strong>Localize seu arquivo ou arraste e solte aqui</strong> para que seja enviado. Ele dever estar em formato <strong>png</strong>, <strong>jpg</strong> ou <strong>pdf</strong>, e deve ter no <strong>máximo 2 Mb</strong>"
    },
    "automated": {
      "forUsers": "Para usuários criados a partir de data definida",
      "forAll": "Para todos os usuários",
      "notifyEmail": "Dispara e-mail da inscrição"
    },
    "termsOfUse": {
      "structure": "Estrutura do Termo de Uso",
      "user": "Nome do usuário Logado",
      "unit": "Nome da unidade de negócio do usuário logado",
      "department": "Nome do departamento do usuário logado",
      "jobTitle": "Cargo do usuário logado",
      "dateTime": "Data e hora do sistema",
      "date": "Data do sistema",
      "hour": "Hora do sistema",
      "defaultContent": "Informe o termo de uso, que será apresentado para os usuários na Plataforma."
    },
    "notes": {
      "title": "Minhas anotações",
      "view": "Visualizar Minhas Anotações",
      "insert": "Inserir Minha anotação"
    },
    "certificateValidation": {
      "title": "Validar Certificado",
      "introduction": "Valide aqui a autenticidade dos certificados. Utilize o código único, localizado no arquivo do seu certificado, para confirmar sua validade.",
      "example": "Este código costuma ser extenso, contendo letras e número separados por hífens, como no exemplo: CC-209G00123",
      "certCode": "Código do Certificado"
    },
    "search": {
      "resultsCountWithQuery": "Exibindo <span class='font-semibold'>{count}</span> de <span class='font-semibold'>{total}</span> resultados para <span class='font-semibold'>&quot;{query}&quot;</span>",
      "resultsCount": "Exibindo <span class='font-semibold'>{count}</span> de <span class='font-semibold'>{total}</span> resultados"
    }
  },
  "column": {
    title: "Título",
    noTitle: "Sem Título",
    "type": "Tipo",
    "situation": "Situação",
    "status": "Status",
    "expired": "Expirado",
    "required": "Obrigatório",
    "obligation": "Obrigação",
    "origin": "Origem",
    "subscribedAt": "Inscrito em",
    "completedAt": "Concluído em",
    "student": "Aluno",
    "institution": "Instituição",
    "createdAt": "Criado em",
    "updatedAt": "Atualizado em",
    "dueDate": "Expira em",
    "requestStatus": "Status da Solicitação",
    "description": "Descrição",
    "workload": "Carga Horária",
    "duration": "Duração",
    "startDate": "Dt. de Início",
    "endDate": "Dt. de Término",
    "certificateUrl": "URL do Certificado",
    "credentialCode": "Código da Credencial",
    "credentialUrl": "Link da Credencial",
    "identifier": "Identificador",
    "inscriptionOrigin": "Origem da Inscrição",
    "name": "Nome",
    "onGoing": "Em Andamento",
    "trainingHours": "Horas de Treinamento",
    "access": "Acesso | Acessos",
    "timeAccess": "Data e Hora de Acesso",
    "consumedContent": "Conteúdo Consumido",
    "userAccess": "Acesso do Usuário | Acessos do Usuário",
    "numAccess": "Quantidade de Acessos | Quantidade de Acessos",
    "lastAccess": "Último Acesso | Últimos Acessos",
    "completedDate": "Dt. de Conclusão",
    "contentName": "Nome do Conteúdo",
    "inscriptionDate": "Dt. da Inscrição | Dt. das Inscrições",
    "consumption": "Consumo",
    "unit": "Unidade | Unidades",
    "phone": "Número de Telefone",
    "accountId": "ID da Conta",
    "classification": "Classificação do Cliente",
    "contractDate": "Data do Contrato",
    "qtyUsers": "Quantidade de Usuários",
    "diskSpace": "Espaço em Disco {0}",
    "courseLimit": "Limite de Cursos",
    "trailLimit": "Limite de Trilhas",
    "defaultUrl": "URL Padrão",
    "communicationEmail": "Email de Comunicação",
    "contactPersonName": "Nome da Pessoa de Contato",
    "contactPersonEmail": "Email da Pessoa de Contato",
    "contactPersonPhone": "Telefone da Pessoa de Contato",
    "companyType": "Tipo de Empresa",
    "managerName": "Nome do Gerente",
    "managerDocument": "Documento do Gerente",
    "managerEmail": "Email do Gerente",
    "observation": "Observação",
    "customUrl": "URL Personalizada",
    "parentUnit": "Unidade Pai",
    "fileType": "Tipo de Arquivo",
    "score": "Nota de Aprovação",
    "showTimer": "Exibir Cronômetro",
    "canRetry": "Permitir Tentativas",
    "maxRetries": "Número Máximo de Tentativas",
    "maxQuestions": "Número Máximo de Perguntas",
    "shuffleQuestions": "Embaralhar Perguntas",
    "shuffleOptions": "Embaralhar Alternativas",
    "displayAnswers": "Exibir Respostas Corretas e Incorretas",
    "coverLink": "Link da Capa",
    "environment": "Ambiente",
    "sharedSection": "Seção Compartilhada",
    "bannerLink": "Link do Banner",
    "redirectLink": "Link de Redirecionamento",
    "initialPubDate": "Data de Publicação Inicial",
    "finalPubDate": "Data de Publicação Final",
    "period": "Período",
    "alwaysDisplay": "Sempre Exibir",
    "supervisorCopied": "Supervisor copiado",
    "version": "Versão",
    "registrationDate": "Dt. de Cadastro",
    "justification": "Justificativa",
    "product": "Produto | Produtos",
    "inscription": "Inscrição | Inscrições",
    "dateDispatch": "Data de envio",
    "displayIn": "Exibir em",
    "reach": "Alcance",
    descriptionAccount: "Descrição da Conta"
  },
  "smtp": {
    "generalInfo": "Informações Gerais",
    "loadingText": "Aguarde enquanto os dados são carregados.",
    "noProviderTitle": "Nenhum provedor de e-mail configurado!",
    "noProviderText": "Para enviar e-mails, é necessário configurar um provedor de e-mail. Clique em 'Adicionar' para adicionar um novo.",
    "dailyLimitTitle": "Limite de e-mails diários!",
    "dailyLimitText": "O envio de e-mails está sujeito a limites diários, os quais são definidor pelos servidores de e-mail de terceiros utilizados. Estes limites podem variar dependendo do provedor de e-mail e suas configurações específicas.",
    "providerName": "Nome do Provedor",
    "emailPlaceholder": "Ex: contato{'@'}provedor.com",
    "authenticationType": "Tipo de Autenticação",
    "host": "Host",
    "encryptedDataPlaceholder": "Dado Criptografado",
    "port": "Porta",
    "encryptionType": "SSL/TLS",
    "encryptionStartTls": "StartTls",
    "encryptionSslOnConnect": "SslOnConnect",
    "oauth2ConfigTitle": "Configuração OAuth2",
    "oauth2ConfigText": "A configuração OAuth2 permite que você utilize provedores de e-mail populares sem a necessidade de gerenciar credenciais SMTP diretamente. Certifique-se de ter as informações do Client ID e Client Secret fornecidas pelo provedor escolhido.",
    "oauth2ProviderQuery": "Qual o provedor de E-mail?",
    "clientId": "Client ID",
    "clientSecret": "Client Secret",
    "removeProvider": "Remover Provedor",
    "testConnection": "Testar Conexão",
    "saveChangesSuccess": "Configurações de provedor salvas com sucesso!",
    "saveChangesError": "Erro ao salvar as configurações. Confira os dados e tente novamente.",
    "testConnectionSuccess": "Teste de conexão bem sucedido!",
    "cancelEdition": "Cancelar Edição",
    "saveChanges": "Salvar Alterações",
    "authTypeBasic": "Básico",
    "authTypeOAuth2": "OAuth2",
    "removeConfirmMessage": "Você tem certeza que deseja remover o provedor de e-mail?",
    "encryptionNone": "Nenhum"
  },
  "months": {
    "jan": "Janeiro",
    "feb": "Fevereiro",
    "mar": "Março",
    "apr": "Abril",
    "may": "Maio",
    "jun": "Junho",
    "jul": "Julho",
    "aug": "Agosto",
    "sep": "Setembro",
    "oct": "Outubro",
    "nov": "Novembro",
    "dec": "Dezembro"
  },
  "gamification": {
    "title": "Acompanhe sua jornada",
    "points": "Pontos",
    "ranking": "Classificação Geral",
    "myJourney": "Minha Jornada",
    "conquered": "Conquistado em",
    "latestAchievements": "Últimas Conquistas",
    "status": {
      "error": "Não foi possível recuperar a lista de conquistas.",
      "emptyData": "Não há dados para exibir ainda."
    },
    "fullJourney": "Minha jornada completa",
    "earnMorePoints": "Ganhe mais pontos",
    "pointsTag": "+{points} pts",
    "pointsEarnedTag": "{points} pts",
    "itemCompetitions": "Este conteúdo pontua em {count} competição: | Este conteúdo pontua em {count} competições:",
    "place": "{position}º lugar",
    "history": "Histórico de conquistas",
    "moorningSun": "Bom dia para o sol",
    "nightMoon": "Boa noite para a lua",
    "nightStars": "Boa noite para as estrelas",
    "won": "Você ganhou!",
    "getPoints": "Obter pontos",
    "achievementReceived": "Confira essa conquista que recebi!",
    "overallRanking": "Classificação Geral",
    "unitRanking": "Classificação na Unidade",
    "getApproval": "Obter aprovação",
    "completeAllItems": "Obter 100% de progresso",
    "getApprovalWithinPeriod": "Obter aprovação dentro do limite de dias definido no desafio",
    "completeAllItemsWithinPeriod": "Obter 100% de progresso dentro do limite de dias definido no desafio",
    "fillPersonalDataInMyProfile": "Preencher os dados pessoais no meu perfil",
    "fillSkillsInMyProfile": "Preencher competências no meu perfil",
    "tiebreakerTitle": "Critério de desempate:",
    "tiebreakerText": "Em caso de empate, fica à frente quem alcançou a pontuação primeiro.",
    "rewardRequestEyebrow": "Solicitação enviada",
    "rewardRequestTitle": "Pontos solicitados",
    "retroactiveScoring": {
      "disableWarning": "Ao desativar esta opção, os pontos retroativos já concedidos aos participantes serão estornados e o ranking da competição será recalculado.",
      "disableTitle": "Desativar pontuação retroativa?",
      "disableMessage": "Os pontos retroativos já concedidos aos participantes serão estornados e o ranking da competição será recalculado.<br /><br />O estorno acontece ao salvar a competição.",
      "disableConfirm": "Desativar"
    }
  },
  "helpers": {
    "profile": "Aqui você pode definir algumas regras de segmentação de conteúdo por habilidades, atualizar seus dados pessoais e profissionais, além de escolher aquela foto especial para o seu perfil (em formato .JPG ou .PNG, com <strong>200 x 200</strong> pixels). Você também pode anexar um arquivo de até <strong>1 MB</strong> de tamanho.",
    "repository": "Aqui, você pode inserir objetos de aprendizagem no formato de Link Externo, que fornece acesso a conteúdos de vídeo de plataformas como Vimeo, Youtube, entre outros links, incluindo acesso a salas de reunião no Teams, Zoom e Google Meet.",
    "cardImage": "Insira a imagem do card para o objeto nos formatos .JPEG, .JPG, .JFIF, .WEBP, .GIF ou .PNG.",
    "recommended": "Recomendamos imagens com <strong>{dimension}</strong> pixels. Anexe um arquivo com um tamanho de até <strong>{size}</strong>.",
    "objectDetails": "Forneça detalhes para o objeto de aprendizagem.",
    "associateQuestions": "Agora vamos associar as perguntas!",
    "structureQuestions": "Aqui, você pode definir a estrutura das suas perguntas e vinculá-las à avaliação.",
    "courseDetails": "Forneça detalhes do curso!",
    "associateObjects": "Agora, vamos associar objetos ao curso.",
    "createSteps": "Que tal criar as etapas para a sua trilha?",
    "structureObject": "Aqui, você estruturará seu curso com objetos já inseridos no repositório e materiais adicionais para os alunos.",
    "stepsCourse": "Nesta etapa, você pode estabelecer as principais regras para o consumo, segmentação e distribuição de conteúdo. Que tal acessar o menu de <strong>Ajuda</strong> e aprender tudo sobre cada parâmetro?",
    "stepsTrail": "Nas etapas, você poderá associar objetos de aprendizagem, cursos e materiais complementares",
    "sectionCommunication": "Insira a imagem para a área de seção do aluno nos formatos .JPG ou .PNG. Recomendamos imagens com dimensões de <strong>1152 x 335</strong> pixels. Anexe um arquivo com tamanho máximo de <strong>3 MB</strong>.",
    "associateContent": "Agora, vamos associar o conteúdo!",
    "associateStructure": "Aqui, você define a estrutura da sua seção adicionando cursos ou trilhas para o acesso dos alunos.",
    "mainRules": "Nesta etapa, você pode estabelecer as principais regras para o consumo, segmentação e distribuição de conteúdo",
    "dontWorry": "Não se preocupe em preencher os filtros; quando deixados em branco, eles mostrarão tudo!",
    "postImage": "<strong>Localize seu arquivo ou arraste e solte aqui</strong> para que seja enviado. Ele dever estar em formato <strong>png</strong> ou <strong>jpg</strong>, e deve ter no <strong>máximo 2 Mb e 800x600 pixels.</strong>",
    "associateRules": "Agora vamos associar regras ao seu desafio.",
    "structureAssocaiteRules": "Aqui você criará a estrutura dos seus desafios usando regras existentes e, em seguida, os vinculará a cursos e trilhas.",
    "challengesGeneralRules": "Nesta etapa, você pode definir as principais regras para os desafios e vinculá-los a cursos e trilhas. Dúvidas? Basta acessar o menu Ajuda e saber tudo sobre cada parâmetro!",
    "bannerLearning": "Insira a imagem para a área interna do aluno no formato .JPG ou .PNG. Recomendamos imagens com as dimensões de <strong>1156 x 384</strong> pixels. Anexe um arquivo com até <strong>3 MB</strong> de tamanho.",
    bannerLogin: "Insira a imagem para a área externa de login do usuário no formato .JPG ou .PNG. Recomendamos imagens com as dimensões de {dimensions} pixels. Anexe um arquivo com até {fileSize} de tamanho.",
    "readQrcode": "Para ler esse código, você pode usar um app leitor de QR ou alguns apps de câmera no seu smartphone.",
    "automatedTitle": "Agora vamos criar as jornadas para seus {object} | Agora vamos criar as jornadas para suas {object}",
    "automatedDescription": "Aqui você poderá criar jornadas automatizadas para as inscrições de seus usuários. Que tal clicar no botão Associar e começar agora mesmo?",
    "automatedRules": "Nesta etapa você pode definir as principais regras para sua automação. Que tal acessar o menu Ajuda e saber tudo sobre cada parâmetro?",
    "stageNoItems": "Essa etapa não possui itens vinculados",
    "notAvailable": "que está tentando acessar não está mais disponível para visualização, por favor entre em contato com o administrador",
    "noNotes": "Aqui você pode visualizar, editar e excluir notas de suas aulas. Elas o ajudarão a retornar rapidamente a momentos interessantes ou desafiadores mais tarde.",
    "hideSystemChat": "Ocultar chat de ajuda da Plantar Educação",
    "hideSystemChatTT": "Exibe o chat de ajuda da plantar ao selecionar a opção \"ajuda\" no menu de usuário, ou em \"fale conosco\" na tela de login.",
    "sendObject": "Envie seu objeto",
    "acceptImage": "Arraste e solte aqui, ou localize o seu arquivo. Ele deve ser no formato Imagem, e ter no máximo 1 GB.",
    "acceptItems": "Arraste e solte aqui, ou localize o seu arquivo. Ele deve ser no formato Vídeo, PDF, Áudio, Imagem, Documento ou Scorm e ter no máximo 1 GB."
  },
  "noContent": {
    myJourneys: {
      title: 'Nenhuma jornada disponível ainda!',
      message: 'Mas não se preocupe, assim que novas jornadas forem liberadas, você verá tudo por aqui!',
      buttonText: 'Ver Catálogo'
    },
    journeys: {
      title: 'Vamos criar as Jornadas?',
      message: 'Aqui você pode criar jornadas de aprendizado, vinculando cursos, trilhas e mídias do depósito e direcioná-las para usuários ou para o público desejado. Que tal clicar no botão abaixo e começar agora mesmo?',
      buttonText: 'Nova Jornada'
    },
    "companies": {
      "title": "O primeiro passo é criar as empresas!",
      "message": "Você precisa criar empresas (indivíduos ou pessoas jurídicas) que serão incluídas na sequência dos seus contratos, entendido. Clique no botão abaixo e comece a inserir registros.",
      "buttonText": "Nova Empresa"
    },
    "contracts": {
      "title": "Vamos criar seus Contratos?!",
      "message": "Você poderá criar e acompanhar seus contratos individualmente por cliente: consumo, módulos contratados e fornecer suporte para processos do cliente. Que tal clicar no botão abaixo e começar agora mesmo?",
      "buttonText": "Novo Contrato"
    },
    "units": {
      "title": "Vamos criar sua estrutura organizacional?",
      "message": "Você pode construir a estrutura da sua unidade com até 5 níveis. Que tal clicar no botão abaixo e começar agora mesmo?",
      "buttonText": "Nova Unidade"
    },
    "departments": {
      "title": "Vamos criar seus departamentos?",
      "message": "Aqui, você pode criar departamentos para vincular aos usuários, facilitando a gestão. Que tal clicar no botão abaixo e começar agora mesmo?",
      "buttonText": "Novo Departamento"
    },
    "jobsTitles": {
      "title": "Vamos criar seus cargos?",
      "message": "Aqui, você pode criar cargos para vincular aos usuários, facilitando a gestão. Que tal clicar no botão abaixo e começar agora mesmo?",
      "buttonText": "Novo Cargo"
    },
    "users": {
      "title": "Vamos criar usuários e acessos?",
      "message": "Aqui, você pode criar seus usuários e definir padrões de acesso. Que tal clicar no botão abaixo e começar agora mesmo?",
      "buttonText": "Novo Usuário"
    },
    "repository": {
      "title": "Vamos criar seus objetos?",
      "message": "Que tal manter todos os seus objetos de aprendizagem em um só lugar? Aqui, você pode categorizá-los por tipos, etc., e usá-los posteriormente associando-os a cursos e trilhas. Clique no botão abaixo e comece a adicionar objetos.",
      "buttonText": "Novo Objeto"
    },
    "tests": {
      "title": "Vamos criar seus testes?",
      "message": "Aqui, você pode criar testes, vinculá-los a cursos e trilhas, e até direcioná-los ao público desejado. Que tal clicar no botão abaixo e começar agora mesmo?",
      "buttonText": "Novo Teste"
    },
    "courses": {
      "title": "Vamos criar seus cursos?",
      "message": "Agora que você estruturou objetivos de aprendizagem no repositório, pode começar a criar seus cursos rapidamente. Que tal começar agora mesmo!",
      "buttonText": "Novo Curso"
    },
    "trails": {
      "title": "Vamos criar suas trilhas?",
      "message": "Inicie sua trilha inserindo informações gerais, em seguida, forneça uma sinopse. Em seguida, você pode criar etapas e associar objetos de aprendizagem. Que tal começar agora mesmo?",
      "buttonText": "Nova Trilha"
    },
    "sections": {
      "title": "Vamos criar suas Seções?",
      "message": "Aqui você pode criar Seções, vincular cursos, caminhos ou comunicação e até direcioná-los ao público desejado. Que tal clicar no botão abaixo e começar agora mesmo?",
      "buttonText": "Nova Seção"
    },
    "manageCertificates": {
      "title": "Vamos gerenciar Certificados Externos?",
      "message": "Aqui, você pode aprovar ou negar solicitações de Certificados Externos enviadas por usuários da plataforma."
    },
    "communication": {
      "title": "Vamos criar suas comunicações?",
      "message": "Aqui você pode criar comunicações em destaque, facilitando a comunicação com os usuários. O que acha de clicar no botão abaixo e começar agora mesmo?",
      "buttonText": "Nova Comunicação"
    },
    "notifications": {
      "title": "Vamos criar suas notificações?",
      "message": "Aqui você pode criar notificações automatizadas, que serão enviadas com base nos eventos definidos ao cadastrar. O que acha de clicar no botão abaixo e começar agora mesmo?",
      "buttonText": "Nova Notificação"
    },
    "challenges": {
      "title": "Vamos criar seus desafios?",
      "message": "Aqui você pode utilizar as regras disponíveis para criar seus próprios desafios e direcionar aos cursos e trilhas. O que acha de clicar no botão abaixo e começar agora mesmo?",
      "buttonText": "Novo Desafio"
    },
    "skills": {
      "title": "Vamos criar suas competências?",
      "message": "Aqui você pode criar competências para vincular na gestão e em conteúdos. Que tal clicar no botão abaixo e começar agora mesmo?",
      "buttonText": "Nova Competência"
    },
    "categories": {
      "title": "Vamos criar suas categorias?",
      "message": "Aqui você pode criar categorias para vincular ao depósito, cursos e trilhas, facilitando a gestão. Que tal clicar no botão abaixo e começar agora mesmo?",
      "buttonText": "Nova Categoria"
    },
    "segmentations": {
      "title": "Vamos criar suas segmentações?",
      "message": "Aqui você pode criar suas segmentações para vincular aos usuários, facilitando a gestão. Que tal clicar no botão abaixo e começar agora mesmo?",
      "buttonText": "Nova Segmentação"
    },
    "certificates": {
      "title": "Vamos criar seus certificados?",
      "message": "Que tal criar certificados personalizados para seus cursos e trilhas? Clique no botão abaixo e comece agora mesmo!",
      "buttonText": "Novo Certificado"
    },
    "permissions": {
      "title": "Você pode criar Grupos de Permissões!",
      "message": "Aqui você pode criar seus próprios perfis de acesso, definindo quais rotinas seus usuários podem acessar, criando grupos de permissões. Que tal clicar aqui e começar agora mesmo?",
      "buttonText": "Novo Grupo de Permissão"
    },
    "customizations": {
      "title": "Vamos personalizar o seu ambiente?",
      "message": "Aqui você pode configurar o seu ambiente. Que tal dar a ele a sua identidade visual, incluindo banners, cores, logotipo, entre outros?",
      "buttonText": "Personalizar Ambiente"
    },
    "termsOfUse": {
      "title": "Vamos criar os seus termos de uso?!",
      "message": "Aqui você pode criar condições de uso e vincular à plataforma, cursos ou trilhas. O que acha de clicar no botão abaixo e começar agora mesmo ?",
      "buttonText": "Novo termo de uso"
    },
    "externalCertificates": {
      "title": "Vamos criar seus Certificados Externos?",
      "message": "Aqui você pode lançar seus certificados emitidos em outras plataformas. O que acha de clicar no botão abaixo e começar agora mesmo?",
      "buttonText": "Novo certificado externo"
    },
    "wellBeingIndicator": {
      "title": "Vamos criar seus indicadores de bem-estar?",
      "message": "Aqui vocé pode criar seus indicadores de bem-estar e vincular. O que acha de clicar no botão abaixo e comecar agora mesmo?",
      "buttonText": "Novo indicador"
    }
  },
  "dialogs": {
    "ops": "ops!",
    "confirmation": "Confirmação!",
    "setClientMode": {
      enter: "Entrar em modo cliente",
      exit: "Sair do modo cliente",
      msgEnter: "<p>Você está prestes a acessar o ambiente do cliente para o contrato selecionado.</p> Atenção! Todas as ações (mudanças de layout, cadastros, manutenção, etc.) afetarão o ambiente de produção do cliente: <strong>{companyName}</strong>. <p>Você tem certeza de que deseja continuar?</p>",
      msgExit: "Tem certeza de que deseja sair do modo cliente? Você será redirecionado para a tela de contratos."
    },
    "delete": {
      "title": "Atenção",
      "message": "<p>Você está prestes a remover {type}: <strong>{name}</strong></p><p>Essa ação não pode ser desfeita!</p>",
      "journeyWithUsers": {
        "message": "Atenção, já existe usuários vinculados a jornada, tem certeza que deseja continuar com a exclusão?"
      }
    },
    "recoverPassword": {
      "usersWarningRequest": "Não foi possível enviar pedido(s) para {0} usuário(s)",
      "usersErrorRequest": "Não foi possível enviar pedido(s) para <strong>{0}</strong> usuário(s): <strong>{1}</strong>."
    },
    "removePermissions": {
      "title": "Remover permissões",
      "message": "Deseja remover as permissões do usuário selecionado? | Deseja remover as permissões dos usuários selecionados?"
    },
    "recoveryPassword": {
      "message": "Enviando pedido(s) de recuperação de senha..."
    },
    "executeManualNotification": {
      "title": "Atenção",
      "message": "<p>Você está prestes a executar manualmente o fluxo de notificação. Isso enviará e-mails para os alunos afetados.</p></br><p>Tem certeza de que deseja prosseguir?</p>"
    },
    "tests": {
      "moreThanTrue": "<p>Há mais de uma opção marcada como verdadeira. Se você alterar o tipo de pergunta para <strong>objetiva</strong>, todas as opções serão marcadas como 'falsas'.<p><p>Você tem certeza de que deseja continuar?</p>",
      "removeQuestion": "Você realmente deseja excluir a pergunta indicada?",
      "removeSkills": "Você realmente deseja remover <strong>{name}</strong>?"
    },
    "sections": {
      "changeSegmentation": "<p>Esta seção já tem segmentações definidas. Continuar removerá esses links.</p><p>Você deseja continuar?</p>",
      "changeDepartment": "<p>Esta seção já tem uma unidade, departamento ou cargo definido. Continuar removerá esses links.</p><p>Você deseja continuar?</p>"
    },
    "challenges": {
      "deleteRule": "Você realmente deseja excluir a regra indicada?"
    },
    "certificates": {
      "remove": "Você realmente deseja remover este elemento?"
    },
    "customizations": {
      "changeTermOfUse": "<p>Você alterou os termos de uso padrão, então todos os alunos serão notificados em sua próxima entrada para aceitar os novos termos.</p><p>Deseja continuar?</p>",
      "removeBanner": "<p>Tem certeza de que deseja remover o banner? <strong>Essa ação não pode ser desfeita</strong>!</p><p>No entanto, se desejar, você pode inserir um ou mais banners usando esta rotina.</p>",
      "removeBgLogin": "<p>Esta imagem de fundo parecia legal :(.</p><p>Posso realmente dizer tchau para ela?...<p><strong>Aperte 'confirmar', e a imagem vai embora</strong>.</p>",
      removeImage: "<p>Tem certeza de que deseja remover a imagem? <strong>Essa ação não pode ser desfeita</strong>!</p><p>No entanto, se desejar, você pode inserir uma nova imagem usando esta rotina.</p>",
    },
    "partner": {
      "title": "Definir como empresa padrão",
      "message": "<p>Você realmente deseja definir a empresa: <strong>{name}</strong> como padrão?</p>"
    },
    "externalCertificates": {
      "title": "Aprovar certificado externo?",
      "message": "<p>Você deseja aprovar esse curso? o aluno será notificado imediatamente</p>"
    },
    "inscriptions": {
      "removeMoreThanOne": "Deseja cancelar <strong>{count}</strong> inscrições selecionadas?",
      "removeOne": "Deseja cancelar a inscrição do aluno selecionado?"
    },
    "automated": {
      "inscriptions": "<p>Caso possua inscrição de alunos vinculado a este curso ou trilha, a mesma será cancelada ao confirmar.</p>Deseja continuar?<p>"
    },
    "repository": {
      "fileExists": "Já existe um arquivo em anexo, deseja prosseguir? (Se sim, o arquivo será desanexado)",
      "linkExists": "Já existe um link inserido, deseja prosseguir? (Se sim, o link será removido)",
      "removeFile": "Deseja realmente remover a mídia atual?"
    }
  },
  "toasts": {
    "genericError": "Ocorreu um erro inesperado. Tente novamente em instantes.",
    "aiLimitError": "O serviço de IA está temporariamente sobrecarregado ou atingiu o limite de requisições. Tente novamente em alguns instantes.",
    "aiError": "Erro ao comunicar com o serviço de IA. Tente novamente.",
    "failedLoadingMap": "Não foi possivel carregar o mapa de estados! Recarregue a página e tente novamente",
    "invalidFile": "Formato de arquivo inválido",
    "acceptFiles": "Os formatos aceitos são {0}",
    "updateSuccess": "Registro atualizado com sucesso",
    "createSuccess": "Registro cadastrado com sucesso",
    "removeSuccess": "Registro removido com sucesso",
    "sentSuccess": "Registro enviado com sucesso",
    "contactManager": "Entre em contato com seu gestor",
    "sendAnswer": "Resposta enviada com sucesso",
    "removePermissions": {
      "sending": "Removendo permissões",
      "successTitle": "Permissões removidas com sucesso!",
      "successMessage": "As permissões foram removidas"
    },
    "repository": {
      "objectNoFile": "Não é possível salvar um objeto sem um arquivo!",
      "objectNoLink": "Não é possível salvar um objeto sem inserir um link válido!",
      "scormType": "Não é possível salvar um Scorm sem especificar seu tipo!",
      "cancelTransfer": "Cancelada pelo usuário",
      "uploadCover": "da imagem de capa",
      "invalidQrcode": "Link do arquivo inválido para gerar QRCode!"
    },
    "tests": {
      "trueOrFalse": "É possível inserir apenas duas opções em perguntas Verdadeiro/Falso.",
      "noDescription": "Existem opções sem descrições!",
      "oneTrue": "É necessário inserir pelo menos uma opção correta!",
      "addOption": "É necessário inserir uma opção",
      "notSave": "A avaliação não pode ser salva sem nenhuma pergunta!"
    },
    "communication": {
      "requiredPost": "É necessário inserir uma postagem!",
      "requiredTitle": "É necessário inserir um título ou imagem na postagem!"
    },
    "challenges": {
      "addOption": "É necessário associar um item para avançar para a próxima etapa!",
      "points": "A pontuação deve ser maior que zero!",
      "itemToCreate": "É necessário associar um item para criar o desafio!"
    },
    "skills": {
      "observation": "Forneça um resumo sobre a competência que está incluindo."
    },
    "login": {
      "errorLoadingInfo": "Erro ao carregar informações adicionais",
      "inactiveUser": "Usuário inexistente ou inativo. Entre em contato com o suporte ou administrador.",
      "noPermission": "Usuário sem permissão de acesso. Entre em contato com o administrador."
    },
    "sections": {
      "contractLinked": "Contratos vinculados com sucesso!",
      "sortingSaved": "Ordenação salva com sucesso!"
    },
    "users": {
      "updatedEmail": "E-mail atualizado com sucesso!",
      "defaultAccount": "Conta padrão definida com sucesso!",
      "accessValidated": "Seu acesso foi validado!",
      "resetPassword": "Senha redefinida!",
      "welcome": "Seja bem vindo(a)",
      "updatedPassword": "Sua senha foi atualizada com sucesso!",
      "updatedPasswordBatch": "Senha alterada para {count} usuários"
    },
    "inscriptions": {
      "subscribe": "{0} alunos inscritos com sucesso!",
      "unsubscribe": "{0} inscrições canceladas com sucesso!"
    },
    "system": {
      "saveSuccess": "Parâmetros cadastrados com sucesso"
    },
    "classRoom": {
      "giveUp": "<p>Ao sair da avaliação você perderá o progresso em andamento. Se sua avaliação possuir apenas uma tentativa será considerado como reprovado nesta avaliação.</p>",
      "looseInProgress": "<p>Ao sair da avaliação você perderá o progresso em andamento. Se sua avaliação possuir apenas uma tentativa será considerado <strong>reprovado</strong> nesta avaliação.</p> Deseja continuar?",
      "notReturn": "<p>Ao sair da avaliação você não poderá retornar para realizá-la. Se você preencheu apenas parte das alternativas, as respostas serão desconsideradas.</p>Deseja continuar?",
      "notAnswerReaction": "<p></p>Não deseja responder a avaliação de reação? <strong>Não tem problema! Ao clicar em confirmar marcaremos essa avaliação como concluída. Combinado?</strong></p>"
    },
    "externalCertificates": {
      "selectJustification": "É necessário selecionar uma justificativa!"
    },
    "dashboard": {
      "generatingErrorTitle": "Erro ao gerar certificado",
      "generatingErrorMessage": "Não foi possível gerar o certificado, tente novamente mais tarde"
    },
    "details": {
      "registrationSuccess": "Inscrição realizada com sucesso!",
      "registrationCanceled": "Inscrição cancelada com sucesso!",
      "favoriteSuccess": "Item adicionado aos favoritos com sucesso!",
      "favoriteCanceled": "Item removido dos favoritos com sucesso!",
      "reactionSuccess": "Reação adicionada com sucesso",
      "reactionCanceled": "Reação removida com sucesso"
    }
  },
  "steps": {
    "basicData": "Dados Básicos",
    "offer": "Oferta",
    "settings": "Configurações",
    "contractManager": "Gerir Contratos",
    "generalRules": "Regras Gerais",
    "generalData": "Dados Gerais",
    "associateObjects": "Associar Objetos",
    "personalization": "Personalização"
  },
  "errors": {
    "notSupportStreaming": "Suporte a streaming não é suportado pelo navegador"
  },
  "repository": {
    "title": "Depósito",
    "label": {
      "classic": "Depósito Clássico",
      "modern": "Depósito Moderno",
      "displayDuration": "Exibir Duração",
      "displayCode": "Exibir Código",
      "displayCreatedAt": "Exibir Dt. Criação",
      "displayOrigin": "Exibir Origem",
      "displayExpired": "Exibir Expirado",
      "displayRequired": "Exibir Obrigatório",
      "subtitle": "Legenda|Legendas",
      "chapter": "Capítulo|Capítulos",
      "clickToVisit": "Clique aqui para visitar o link",
      "unavailable": "Indisponível"
    },
    "help": {
      "supportedFilesTitle": "Mídias e formatos suportados!",
      "supportedFilesMessage": "É possível inserir vários tipos de objetos de aprendizado como: Vídeo, PDF, Áudio, Imagem, Documento e Scorm.",
      "supportedLinksTitle": "Formatos de links suportados!",
      "supportedLinksMessage": "É possível inserir links de plataformas como Vimeo, Youtube, entre outros, incluindo acesso a salas de reunião no Teams, Zoom e Google Meet.",
      "unavailable": "Para mais informações, contate seu gestor ou o suporte da plataforma.",
      "cantUploadSubtitlesYet": "Só é possível adicionar legendas após o envio do video e pré-processamento do mesmo.",
      "cantUploadChaptersYet": "Só é possível adicionar capítulos após o envio do video e pré-processamento do mesmo.",
      "chaptersIntroduction": "Os capítulos são exibidos na linha do tempo do vídeo e permitem que os espectadores naveguem com mais facilidade.",
      "noChaptersAddedYet": "Nenhum capítulo adicionado ainda"
    },
    "feedback": {
      "chapterSLE": "O início do capítulo deve ser menor que o final.",
      "chapterEGV": "O final do capítulo não pode ser maior que a duração do vídeo.",
      "chapterOverlap": "Um capítulo não pode se sobrepor a outro capítulo."
    },
    "button": {
      "generateQrCode": "Gerar QRCode"
    },
    "form": {
      "objectType": "Tipo de objeto",
      "objectDuration": "Duração do objeto",
      "durationAutoDetect": "Detectar automaticamente",
      "create": "Criar Objeto de Aprendizado",
      "edit": "Editar Objeto de Aprendizado",
      "downloadable": "Permitir Download",
      "selectScormType": "Selecione o tipo de Scorm",
      "selectCategory": "Selecione a categoria",
      "watermark": {
        "title": "Marca d'água",
        "enable": "Habilitar Marca d'água",
        "userName": "Nome do usuário",
        "userEmail": "E-mail do usuário",
        "company": "Empresa",
        "unit": "Unidade de Negócio",
        "department": "Departamento",
        "position": "Cargo",
        "dateTime": "Data & Hora",
        "userIp": "IP do Usuário"
      },
      "chapter": {
        "start": "Início do Capítulo",
        "end": "Fim do Capítulo",
        "title": "Título do Capítulo"
      }
    }
  },
  "permissionGroup": {
    "form": {
      "titleAdd": "Adicionar Grupo de Permissões",
      "titleEdit": "Editar - {name}",
      "name": "Nome do Grupo de Permissões",
      "namePlaceholder": "Informe o nome do grupo de permissões",
      "hint1": "Selecione todas as funcionalidades que serão disponibilizadas para os usuários deste grupo.",
      "selectFunctionality": "Selecione as funcionalidades"
    }
  },
  "versionManager": {
    "newVersion": "Nova Versão",
    "newAvailable": "Nova versão disponível",
    "newInstructions": "Clique no botão 'Atualizar' ou recarregue a página para aplicar as atualizações.",
    "update": "Atualizar"
  },
  role: {
    all: "Todos",
    admin: "Administrador",
    manager: "Gestor",
    student: "Aluno"
  },
  dashboard: {
    splash: {
      title: "Explore seus Dashboards!",
      description: "Acesse os painéis disponíveis na barra superior e visualize dados essenciais para acompanhar o desempenho e tomar decisões estratégicas.",
      report: {
        title: "Explore seus Relatórios!",
        description: "Acesse os relatórios disponíveis na barra superior e obtenha análises detalhadas para acompanhar resultados e embasar suas decisões estratégicas.",
      }
    }
  },
  assessmentGiveupResult: {
    title: 'Desistência registrada!',
    message: 'Você pode iniciar uma nova avaliação se ainda houver tentativas disponíveis.'
  },
  contract: {
    label: {
      enableAAD: 'Permitir que o usuário faça Login via Single Sign On?',
      enableTwoFactor: 'Exigir verificação em duas etapas no login?',
      yes: 'Sim, permitir',
      no: 'Não, não permitir',
      selectProvider: "Selecione o Provedor",
      AAD: {
        id: "ID do Cliente AAD",
        tenantId: "Tenant ID AAD",
        url: "URL da Instância AAD",
        redirectUri: "URL de Retorno de Autenticação AAD",
        provider: "Provider",
        clientSecret: "Segredo do Cliente AAD"
      },
      Amazon: {
        "clientId": "ID do Cliente",
        "tenantId": "Tenant ID",
        "instanceUrl": "URL da Instância",
        "userPool": "User Pool",
        "authCallbackUrl": "URL de Retorno de Autenticação",
        "company": "Empresa",
        "clientSecret": "Client Secret"
      },
      inactiveContract: "<p>Deseja realmente inativar este contrato?</p><br><p>Ao prosseguir, todos os usuários vinculados serão inativados e terão suas permissões removidas.</p><p>A empresa associada ao contrato também será inativada quando você salvar as alterações.</p>"
    },
    tooltip: {
      enableAAD: "SSO (Single Sign-On) permite acessar diversos sistemas com uma única autenticação. AAD (Azure Active Directory) é a plataforma da Microsoft que gerencia essa autenticação, oferecendo mais segurança e praticidade.",
      releaseAAD: "As configurações inseridas só terão efeito após o reinício da aplicação. Isso significa que, após o preenchimento e a confirmação das informações, será necessário reiniciar o sistema para que as alterações sejam aplicadas corretamente. Entre em contato com o suporte ou aguarde 48 horas para ser aplicado automaticamente.",
      enableTwoFactor: "Ao entrar com usuário e senha, a pessoa recebe um código por e-mail e precisa informá-lo para concluir o login. Vale para todos os usuários desta conta. Importante: quem não tiver um e-mail válido cadastrado não conseguirá entrar, porque não há como receber o código.",
      AAD: {
        id: "O Clientld é o identificador único para seu aplicativo registrado no Azure AD. Esse valor é gerado ao registrar o aplicativo no Azure AD.",
        tenantId: "O TenantId é o identificador da conta para seu aplicativo registrado no Azure AD. Esse valor é gerado ao registrar o aplicativo no Azure AD.",
        url: "O Aadlnstance é a URL base do serviço de autenticação do Azure AD.",
        redirectUri: "Ele é utilizado para autenticação e autorização.",
        provider: "Neste campo você define o nome da Empresa que será solicitado quando o cliente optar por fazer login via SSO",
        clientSecret: "É a cadeia de caracteres secreta que o aplicativo irá utilizar para provar sua identidade ao solicitar um Token. Também pode ser mencionado como a Senha de Aplicativo."
      },
      Amazon: {
        id: "O Clientld é o identificador único para seu aplicativo registrado na Amazon Cognito. Esse valor é gerado ao registrar o aplicativo no Amazon Cognito.",
        tenantId: "O User Pool é o identificador da conta para seu aplicativo registrado no Amazon Cognito. Esse valor é gerado ao registrar o aplicativo no Amazon Cognito.",
        url: "É a URL base do serviço de autenticação do Amazon Cognito.",
        redirectUri: "Ele é utilizado para autenticação e autorização.",
        provider: "Neste campo você define o nome da Empresa que será solicitado quando o cliente optar por fazer login via SSO",
        clientSecret: "É a cadeia de caracteres secreta que o aplicativo irá utilizar para provar sua identidade ao solicitar um Token. Também pode ser mencionado como a Senha de Aplicativo."
      }
    },
    placeholder: {
      AAD: {
        id: "Digite o ClientId AAD",
        tenantId: "000000000000000000000000",
        url: "Digite a URL da Instância AAD",
        redirectUri: "Digite a URL de Retorno AAD",
        provider: "Digite o Provider",
        clientSecret: "Digite o Segredo do Cliente AAD"
      },
      Amazon: {
        id: "Digite o ClientId",
        userPool: "Digite o User Pool",
        url: "Digite a URL da Instância",
        redirectUri: "Digite a URL de Retorno",
        provider: "Digite a Empresa",
        clientSecret: "Digite o Segredo do Cliente"
      }
    }
  },
  // pt-br
  subscription: {
    title: "Minha Assinatura",
    expired: "Sua assinatura expirou ou está cancelada. Você pode acessar apenas os conteúdos já consumidos para emissão de certificados. Renove a assinatura para retomar o acesso completo!",
    alert: {
      cancelled: "Conforme solicitado, sua assinatura foi cancelada em {date}.",
      useUntil: "Você poderá utilizar a plataforma até {date}.",
      errorLoading: "Não foi possível carregar as informações da sua assinatura. Por favor, tente novamente mais tarde."
    },
    btn: {
      subscriptionPlan: "Plano de Assinatura",
      paymentHistory: "Histórico de Pagamentos",
      cancel: "Cancelar Assinatura",
      reactivate: "Reativar Assinatura"
    },
    label: {
      inCash: "À vista",
      monthly: "Mensal"
    },
    info: {
      subscriberSince: "Assinante desde {date}",
      nextBilling: "Próxima cobrança em {date}",
      paidCreditCardDigits: "Cartão de crédito finalizado em {digits}",
      noSubscription: "Você não possui um plano ativo."
    },
    cancelModal: {
      title: "Cancelar Assinatura",
      info: "Ao clicar em \"Cancelar\", você encerrará seu plano e interromperá a cobrança automática, mas poderá continuar acessando a plataforma até o final do seu período de vigência.",
      cantRefund: "Não será possível solicitar um reembolso, pois o prazo para essa solicitação se encerrou em {date}.",
      contactUs: "Se precisar de ajuda, entre em contato conosco.",
      reason: "Motivo do cancelamento",
      reasonPlaceholder: "Informe o motivo do cancelamento (opcional)",
      keep: "Manter assinatura",
      cancel: "Cancelar assinatura"
    }
  },
  classroomDeviceOrientation: {
    message: 'Para uma melhor experiência na sala de aula, use seu dispositivo na horizontal.',
    dontShowAgain: 'Não mostrar novamente',
    close: 'Fechar Notificação'
  },
  content: {
    label: {
      playbackSettings: "Configurações de Reprodução",
      currentImage: "Imagem Atual",
      coverImage: "Imagem de capa do video",
      insertName: "Insira um nome",
      insertLegend: "Envie uma legenda (clique ou arraste aqui)",
      ready: "Arquivo pronto",
      addLegend: "Adicionar Legenda",
      save: "Armazena as alterações em legendas",
      objectInfo: "Informações do Objeto",
      language: "Idioma",
    },
    info: {
      cardImageInfo: "Esta(s) imagem(ns) será(ão) exibida(s) no cartão da mídia.",
      dropImage: "Solte a imagem aqui!",
      vttSrt: "Adicione legendas ou notas aos vídeos. Os formatos suportados são .VTT e .SRT.",
      changeType: "Deseja realmente alterar o tipo da midia?",
      mediaInfo: "Links e Arquivos são tratados de maneira diferente no sistema."
    },
    placeholder: {
      clickHere: "Clique aqui ou arraste uma imagem",
      insertName: "Insira um nome",
      insertSummary: "Insira um resumo",
      insertSkills: "Vincule as competências",
      insertSections: "Vincule as seções",
      objectCode: "Código unico do objeto (opcional)",
      vttSrt: "Arquivo .VTT ou .SRT, máximo 5 MB",
      dropLegend: "Solte a legenda aqui!",
      noLegend: "Nenhuma legenda adicionada ainda...",
      selectLanguage: "Selecione um idioma"
    },
    feedback: {
      legendAdded: "Legendas Adicionadas"
    }
  },
  modalPlan: {
    //Ativo
    "title": "Bem-vindo {user}!",
    "activated": "Sua assinatura foi ativada",
    "descriptionYearly": "Você adquiriu o acesso anual ao <strong>PlantarFlix</strong>, e sua assinatura será renovada automaticamente a cada 12 meses.",
    "descriptionMonthly": "Você adquiriu o acesso mensal ao <strong>PlantarFlix</strong>, e sua assinatura será renovada automaticamente todo dia {day}.",
    "button": "ACESSAR A PLANTARFLIX",
    "reminder": "Você pode cancelar a qualquer momento antes da data de vencimento.",

    //Inativo
    "expiredTitle": "Olá {user}!",
    "expiredMessage": "Seu tempo de assinatura expirou.",
    "renewalInfo": "Mas não se preocupe, <strong>você pode resolver isso agora</strong> e continuar acessando mais conteúdos do <strong>PlantarFlix</strong>!",
    "accessNote": "Você ainda tem acesso aos conteúdos que você já realizou e aos certificados de conclusão.",
    "support": {
      "text": "Se precisa de ajuda ou tiver alguma dúvida fale agora com nosso",
      "link": "time de suporte."
    },
    "canceledMessage": "Sua assinatura foi cancelada."
  },
  "pdf": {
    "enterPassword": "Insira a senha",
    "fileProtected": "Este documento é protegido por senha.",
    "checkPassword": "Verifique sua senha",
    "cannotOpenFile": "Não é possível abrir este arquivo",
    "somethingWentWrong": "Algo deu errado.",
    "protectedDocument": "Documento Protegido"
  },
  backgroundAndBanner: {
    "customization": {
      "title": "Planos de Fundo e Banners",
      "showCustomization": "Exibir Personalização",
      "backgroundAndBannersInfo": "Informações sobre os <strong>Planos de Fundo e Banners</strong>:",
      "backgroundFieldInfo": "• O campo <strong>Plano de Fundo</strong> aceita imagens e vídeos. E o campo <strong>Banner</strong> aceita apenas imagens.",
      "textTypeInfo": "• Quando o slide for do tipo <strong>Conteúdo</strong>, serão disponibilizados um editor em Markdown e um seletor de cor para a definição de cor do fundo do texto.",
      "reorganizeInfo": "• É possível <strong>reorganizar</strong> os slides arrastando-os pelo ícone ⋮⋮.",
      "noCustomizationConfigured": "Nenhuma personalização configurada",
      "clickAddToCreateFirst": "Clique em \"Adicionar\" para criar sua primeira personalização.",
      "maxCustomization": "• É possivel adicionar até 10 personalizações.",
    },

    "labels": {
      "duration": "Duração (segundos)",
      "alterFile": "Alterar Arquivo",
      "removeFile": "Remover Arquivo",
      "uploadFile": "Upload de Arquivo",
      "transparentBackground": "Fundo Transparente",
      "alterBanner": "Alterar Banner",
      "newTab": "Abrir em nova aba",
      "copyBackground": "Copiar Plano de Fundo",
    },
    "slides": {
      "type": "Tipo:",
      "background": "Plano de Fundo (Imagem/Vídeo)",
      "bannerImage": "Banner (Apenas Imagem)",
      "redirectLink": "Link de Redirecionamento",
      "markdownEditor": "Editor de Conteúdo",
      "backgroundColor": "Cor de Fundo do Conteúdo",
      "transparent": "Transparente"
    },
    "placeholders": {
      "background": "Plano de Fundo",
      "dragOrClick": "Arraste ou clique",
      "dragOrClickBackground": "Arraste ou clique no ícone superior",
      "backgroundDimensions": "1600x960px (4:3)",
      "bannerDimensions": "1156x384px (3:1)",
      "linkPlaceholder": "https://...",
      "enterContent": "Digite seu conteúdo..."
    },
    "confirmations": {
      "removeAllDataLost": "Ao remover, todos os dados serão perdidos. Deseja continuar?"
    },
    "environments": {
      "home": "Início",
      "catalog": "Catálogo",
      "both": "Ambos"
    },
    "notifications": {
      "uploadBackgroundFail": "Falha no upload do plano de fundo do banner {index} : {error}",
      "uploadBannerFail": "Falha no upload do banner {index} : {error}",
      "insertSuccess": "Personalização de plano de fundo e banner do Slide {index} inserida com sucesso!",
      "insertFail": "Falha ao inserir personalização de plano de fundo e banner {index} : {error}",
      "updateSuccess": "Personalização de plano de fundo e banner do Slide {index} atualizada com sucesso!",
      "updateFail": "Falha ao atualizar personalização de plano de fundo e banner {index} : {error}",
      "deleteFail": "Falha ao excluir personalização de plano de fundo e banner com Id {id} : {error}",
      "saveSuccess": "Personalização salva com sucesso!",
      "saveFail": "Falha ao salvar planos de fundo e banners: {error}",
      "loadError": "Erro ao carregar dados existentes: {error}"
    },
    "tooltips": {
      "duration": "Este campo e para determinar o tempo em que o conteúdo ficará visível, até o próximo slide, caso haja múltiplos slides.",
      "environment": "Este campo e para definir o o local onde o conteúdo será exibido",
      "content": "Este campo é para inserir o conteúdo que será exibido no slide quando o tipo selecionado for Conteúdo. O espaço disponível para exibição do conteúdo é de 1156×384 px (proporção 3:1).",
      "backgroundColor": "Este campo é para selecionar a cor de fundo do conteúdo que será exibido no slide quando o tipo selecionado for Conteúdo.",
      "backgroundFieldInfo": "O campo <strong>Plano de Fundo</strong> aceita imagens nos formatos JPEG, PNG, JPG, GIF, WebP e JFIF, com tamanho máximo de 5MB, e vídeos nos formatos MP4, WebM e MKV, com tamanho máximo de 20MB. Caso seja utilizado um vídeo como <strong>Plano de Fundo</strong>, este não poderá conter áudio.",
      "bannerFieldInfo": "O campo <strong>Banner</strong> aceita imagens nos formatos JPEG, PNG, JPG, GIF, WebP e JFIF, com tamanho máximo de 5MB.",
    },

  },
  parameterizations: {
    preRequisites: "Este conteúdo possui requisitos que devem ser concluídos. Para mais informações, acesse a tela de detalhamento do curso/trilha.",
    comsuptionControl: "O acesso ao conteúdo será liberado a partir de: <strong>{availableAt}</strong>"
  },
  wellBeingIndicator: {
    labels: {
      title: 'Título do Indicador',
      description: 'Descrição',
      emojiStyle: 'Estilo de Emoji',
      startDate: 'Data de Início',
      endDate: 'Data de Término',
      frequency: 'Frequência (Dias)',
      segmentation: 'Segmentação',
      required: 'Obrigatório',
      anonymous: 'Anônimo',
      search: 'Pesquisa',
      guys: 'Pessoal',
      professional: 'Profissional'
    },
    placeholder: {
      title: 'Informe o título do indicador',
      reasonSelect: 'Selecione um motivo',
      commentInput: 'Digite aqui seu comentário'
    },
    tooltips: {},
    informations: {
      title: 'Esse será o título exibido para o aluno quando ele responder o indicador de bem-estar. Use um nome claro e direto, por exemplo: "Como você está se sentindo hoje?".',
      description: 'Utilize esse campo para dar contexto ou instruções adicionais para o aluno. Exemplo: "Sua resposta nos ajuda a acompanhar seu bem-estar e melhorar o ambiente de trabalho."',
      emojiStyle: 'Escolha o estilo dos emojis que serão exibidos para os alunos:<ul><li><strong>Estático:</strong> emojis fixos e leves.</li><li><strong>Animado:</strong> emojis com pequenas animações quando selecionados.</li></ul>',
      startDate: 'Data em que o indicador ficará disponível para os alunos. Somente dentro desse período o aluno poderá visualizar e responder.',
      endDate: 'Data final de validade do indicador. Após essa data, ele não será mais exibido aos alunos.',
      frequency: 'Define o intervalo, em dias, entre as exibições do indicador para o mesmo aluno. Exemplo: Se for definido como 3, a pesquisa aparecerá a cada 3 dias dentro do período configurado.',
      segmentation: 'Permite direcionar o indicador para um grupo específico (departamento, unidade, cargo, etc.). Caso não selecione uma segmentação, o indicador será enviado para todos os usuários da plataforma.',
      required: 'Se estiver marcado como obrigatório, o aluno precisará responder antes de continuar utilizando a plataforma. Ele deverá escolher um emoji e um motivo obrigatoriamente.',
      anonymous: 'Quando habilitado, as respostas não serão vinculadas aos dados do aluno. O relatório mostrará apenas os sentimentos, motivos e comentários de forma anônima.'
    },
    messages: {
      requiredSurvey: 'Esta pesquisa é obrigatória. Responda para continuar acessando a plataforma.',
      anonymousSurvey: 'Esta pesquisa é anônima. Suas respostas não serão vinculadas à sua conta.',
      reason: 'Por qual motivo?',
      comment: 'Comente um pouco mais sobre este sentimento'
    },
    emotions: {
      anger: 'Raiva',
      verySad: 'Muito Triste',
      sad: 'Triste',
      upset: 'Chateado',
      insecure: 'Inseguro',
      indifferent: 'Indiferente',
      fine: 'Bem',
      happy: 'Feliz',
      veryHappy: 'Muito Feliz',
      radiant: 'Radiante'
    }
  },
  aliareSegment: {
    partners: "Parceiros",
    otherSmallMediumClients: "Outros clientes de pequeno e médio porte e pessoas físicas",
    fertilizerIndustry: "Indústria de fertilizantes, adubos foliares e nutrição animal",
    inputDistributor: "Distribuidor de insumos",
    warehousesAndTradings: "Armazéns gerais e tradings",
    cooperative: "Cooperativa",
    largeClients: "Outros clientes de grande porte",
    farmersAndRelated: "Produtores agrícolas, sementeiras, algodoeiras e afins",
    dealership: "Concessionária",
    agroRetail: "Varejo de insumos e agropecuário"
  },
  sso: {
    customizeButton: 'Personalizar botão do SSO',
    buttonPreview: 'Preview do Botão',
    buttonName: 'Nome do Botão',
    buttonImageUrl: 'URL da Imagem do Botão',
    continue: 'Continuar com Single Sign-On',
    singleSign: 'Single Sign-On',
    supportedProviders: 'Provedores suportados',
  },
  colorPicker: {
    angle: "Ângulo",
    positionX: "Posição X",
    positionY: "Posição Y",
    solid: "Sólido",
    gradient: "Gradiente",
    linear: "Linear",
    radial: "Radial",
    colorPalette: "Paleta de Cores",
    btnSave: "Salvar",
    btnCancel: "Cancelar"
  },
  "status": {
    "provisioning": {
      "pendente": "Pendente",
      "processando": "Processando",
      "concluido": "Concluído",
      "erro": "Erro"
    }
  },
  "component": {
    "avatarUpload": {
      "title": "Upload de Avatar",
      "dragDrop": "Arraste e solte uma imagem ou clique para selecionar",
      "selectImage": "Abrir Seletor de Imagem"
    }
  }
}